import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { MediaMatcher } from '@angular/cdk/layout';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnInit, QueryList,
    Renderer2,
    RendererFactory2,
    ViewChild, ViewChildren,
    ViewEncapsulation, OnDestroy} from '@angular/core';
import { Subscription } from 'rxjs';
import {GoogleMap, MapInfoWindow, MapMarker, MapPolygon} from '@angular/google-maps';
import { TenantService } from '../services/tenant.service';
import { DroneSurveyService } from '../maps/services/drone-survey.service';
import { MapsTileOverlayService } from '../maps/services/maps-tile-overlay.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, throwError, forkJoin, of, Observable } from 'rxjs';
import { catchError, filter, map, switchMap, finalize } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { AddFarmComponent } from '../dialogs/add-farm/add-farm.component';
import { RainMeterSelectionComponent } from '../dialogs/rain-meter-selection/rain-meter-selection.component';
import { RainfallCaptureComponent } from '../dialogs/rainfall-capture/rainfall-capture.component';
import { HelperService } from '../helper.service';
import { Farm } from '../models/farm';
import { Field } from '../models/field';
import { FieldLegend } from '../models/fieldLegend';
import { History } from '../models/history';
import { RainMeters } from '../models/rainMeters';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import _moment, { default as _rollupMoment } from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AddFieldComponent } from '../dialogs/add-field/add-field.component';
import { DeleteFarmComponent } from '../dialogs/delete-farm/delete-farm.component';
import { DeleteFieldComponent } from '../dialogs/delete-field/delete-field.component';
import { DeleteIndentFieldComponent } from '../dialogs/delete-indent-field/delete-indent-field.component';
import { DeleteInsideFieldComponent } from '../dialogs/delete-inside-field/delete-inside-field.component';
import { EditFieldComponent } from '../dialogs/edit-field/edit-field.component';
import { FieldOptionsComponent } from '../dialogs/field-options/field-options.component';
import { NewFieldComponent } from '../dialogs/new-field/new-field.component';
import { SaveChangesComponent } from '../dialogs/save-changes/save-changes.component';
import { StopDrawingComponent } from '../dialogs/stop-drawing/stop-drawing.component';
import { AddField } from '../models/addField';
import { CirclePolygon } from '../models/circlePolygon';
import { ContaningField } from '../models/containingField';
import { Countries } from '../models/countries';
import { FarmId } from '../models/farmId';
import { FieldId } from '../models/fieldId';
import { FieldName } from '../models/fieldName';
import { MultiPolygon } from '../models/multiPolygon';
import { MultiPolygonField } from '../models/multiPolygonField';
import { Polygon } from '../models/polygon';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RenameFarmComponent } from '../dialogs/rename-farm/rename-farm.component';
import { FarmManagementService } from '../services/farm-management.service';
import { AnalysisManagementService } from '../services/analysis-management.service';
import { MappingService } from '../services/mapping.service';
import { RainfallService } from '../services/rainfall.service';
import { BoundaryManagementService } from '../services/boundary-management.service';
import { Base } from '../services/base';
import { WeatherForecastComponent } from '../weather-forecast/weather-forecast.component';
import { WeatherForecastService } from '../weather-forecast/weather-forecast.service';
import { WeatherStationService } from '../services/weather-station.service';
import { SyncService } from '../services/sync-service';
import { MapDataFarmComponent } from '../map-data/map-data-farm/map-data-farm.component';
import { MapsTypesAvailabilityDto } from '../dto/MapsTypesAvailabilityDto';
import { MapsFarmImageryDto } from '../dto/MapsFarmImageryDto';
import { MapsFarmImageryLegendDto } from '../dto/MapsFarmImageryLegendDto';
import { FarmLegend } from '../models/farmLegend';
import { MapsTypesAvailabilityModel } from '../models/mapsTypesAvailabilityModel';
import dayjs from 'dayjs';
import { SelectedFarmMapsItemModel } from '../models/selectedFarmMapsItemModel';
import { CropType } from '../models/cropType';
import { ViewSavedPinComponent } from '../dialogs/pin-rework-dialogs/view-saved-pin/view-saved-pin.component';
import { PinManagerService } from '../services/pin-manager.service';
import { Pin } from '../models/pin';
import { PinType } from '../models/pinType';
import { DynamicPin } from '../models/dynamicPin';
import { PinClearComponent } from '../dialogs/pin-clear/pin-clear.component';
import { DiseasePinComponent } from '../dialogs/pin-rework-dialogs/disease-pin/disease-pin.component';
import { MarkerPinComponent } from '../dialogs/pin-rework-dialogs/marker-pin/marker-pin.component';
import { PestPinComponent } from '../dialogs/pin-rework-dialogs/pest-pin/pest-pin.component';
//small change
import { SoilPinSamplesComponent } from '../dialogs/pin-rework-dialogs/soil-pin-samples/soil-pin-samples.component';
import { VirtualConsultantPinComponent } from '../dialogs/pin-rework-dialogs/virtual-consultant-pin/virtual-consultant-pin.component';
import { WaterPinComponent } from '../dialogs/pin-rework-dialogs/water-pin/water-pin.component';
import { NewPin } from '../models/NewPin ';
import { SoftTissuePinSamplesComponent } from '../dialogs/pin-rework-dialogs/soft-tissue-pin-samples/soft-tissue-pin-samples.component';
import { environment } from "../../environments/environment";
import { Title } from "@angular/platform-browser";
import { NTesterPinComponent } from '../dialogs/pin-rework-dialogs/n-tester-pin/n-tester-pin.component';
import { YieldEstimationPinComponent } from '../dialogs/pin-rework-dialogs/yield-estimation-pin/yield-estimation-pin.component';
import { AnalysisTitleModel } from '../models/analysis-managment-models/analysis-title-model/analysis-title-model';
import {FieldDetailsService} from "../services/field-details.service";
import {NewSavePinComponent} from "../dialogs/pin-rework-dialogs/new-save-pin/new-save-pin.component";
import {VardaService} from "../services/varda.service";
import { FeatureFlagsService } from '../unleash-feature-flags/feature-flags.service';
import { FieldInspectionDialogComponent } from '../dialogs/pin-rework-dialogs/field-inspection-dialog/field-inspection-dialog.component';
import { summariseFarmRecacheResults } from '../utils/recache-results';

// import {OverlayAllDialogComponent} from '../dialogs/overlay-all-dialog/overlay-all-dialog.component';
// import {OverlayAnalysisDialogComponent} from '../dialogs/overlay-analysis-dialog/overlay-analysis-dialog.component';
// import { GeosysManagementService } from '../services/geosys-management.service';
// import {object} from '@angular/fire/database';
// import {UpdateFarmDto} from '../dto/UpdateFarmDto';


declare var google: any;

const moment = _rollupMoment || _moment;

@Component({
    selector: 'app-mapping',
    templateUrl: './mapping.component.html',
    styleUrls: ['./mapping.component.css'],
    encapsulation: ViewEncapsulation.Emulated,
    animations: [
        trigger('slideInOut', [
            state('in', style({ 'opacity': '1', 'width': '500px', 'padding': '24px 12px 12px' }), { params: { inWidth: '500px' } }),
            state('out', style({ width: '0', 'opacity': '1', 'padding': '0' })),
            transition('in => out', [group([
                    animate('100ms ease-in-out', style({
                        'opacity': '1'
                    })),
                    animate('100ms ease-in-out', style({
                        width: '{{ inWidth }}px'
                    })),
                    animate('100ms ease-in-out', style({
                        padding: '24px 12px 12px'
                    }))
                ])]),
            transition('out => in', [
                animate('100ms ease-in-out', style({
                    'opacity': '1'
                })),
                animate('100ms ease-in-out', style({
                    width: 'o'
                })),
                animate('100ms ease-in-out', style({
                    padding: '0'
                }))
            ])
        ]),
        trigger('rotate', [
            state('in', style({ transform: 'rotate(0deg)' })),
            state('out', style({ transform: 'rotate(180deg)' })),
            transition('in => out', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(0deg)'
                }))
            ]),
            transition('out => in', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(180deg)'
                }))
            ])
        ])
    ],
    standalone: false
})

export class MappingComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('selectFarm', { static: false }) selectFarm: ElementRef;

    @ViewChild('map') agmMap: GoogleMap;

    /** Tenant-change subscription driving the drone imagery backdrop. */
    private droneTenantSub?: Subscription;
    /** Tile access could not be renewed; drop the imagery rather than leave it blank. */
    private droneAccessSub?: Subscription;

    isWeatherForecastEnabled: boolean = false;
    showWeatherCard: boolean = false;
    weatherForecasts: any[] = [];
    isWeatherLoading: boolean = false;

    savedPinStartDate = '';
    savedPinEndDate = '';

    farmOptionsStyle = {
        showOptions: false,
        optionsStyle: {}
    };
    fieldOptionsStyle = {
      showOptions: false,
      optionsStyle: {}
    };
    farmOpened: boolean = true;
    vardaField;
    vardaFieldSize: number = null;
    renderer: Renderer2;

    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;

    title: string = 'AGM project';

    latitude: number = -13.960981;
    longitude: number = 22.804752;

    // latitudeDefault: number = -24.81845;
    // longitudeDefault: number = 24.78616;

    pinMarkers = [];
    tmpMarkers = [];
    pinsCalled = false;
    newSavedPinsData: Pin[] = [];
    newSavedPins = [];
    savedLabelPins = [];
    selectedPinType: PinType;
    savedPinsDataCounter = 0;
    pinCounter = 1;
    tmpId = 0;
    tmpPins: Pin[] = [];
    tmpData: DynamicPin[] = [];
    barChartData: DynamicPin[] = [];

    existingPin: NewPin;
    existingMarker = null;
    openVardaBoundary: boolean = false;
    previousValue: any;

    markers = [];
    centerMarkers = [];
    currentMarkers = [];
    substrings = ['CHEMICAL', 'NI'];

    analysisTypeAvailable: any;

    public zoom = 10;
    public maxMapZoom: number = 4;
    public minMapZoom: number = 10;

    public showTracking: boolean = true;
    public showOverlay: boolean = false;
    public showFields: boolean = true;
    public checkCircle: boolean = false;
    public isAnalysisEmpty: boolean = false;
    public mapsAlreadyOpen: boolean = false;
    isPinMarkersVisible: boolean = false;

    viewPinInfo: boolean = false;

    flex1: number = 20;
    flex2: number = 80;

    center = { lat: this.latitude, lng: this.longitude };

    public tenantId: number;
    public userId: number;

    public farmSubjects = new BehaviorSubject<Farm[]>(null);
    farms$ = this.farmSubjects.asObservable();
    // showAddFarmOption = false;

    public fieldSubjects = new BehaviorSubject<Field[]>(null);
    fields$ = this.fieldSubjects.asObservable();

    public historySubject = new BehaviorSubject<History[]>(null);
    histories$ = this.historySubject.asObservable();

    public histories: History[];
    public activeHistoryId;

    public geoJsonObject: Object[] = [];

    openedWindow: number = 0;
    public isTrackingActive = false;
    private trackingMarker;
    private watchId = -1;
    private location;

    public isLabelsShowing = true;
    public isPinLabelsShowing: boolean = false;

    public ndviHistories: History[];
    public niHistories: History[];
    public soilHistories: History[];
    toggleLegend: boolean = false;

    private rainMeters: RainMeters[];

    activeId = -1;

    farmWidth: number;
    mapping = false;

    tenantChanged = false;

    animationState = 'in';
    farmId = -1;
    farmName = "";
    public fieldCounter = -1;
    fieldId: number;
    startDate = moment().subtract(1, "months").format("YYYY-MM-DD");
    endDate = moment().format("YYYY-MM-DD");

    bounds: any = new google.maps.LatLngBounds();
    farmBounds: any;
    emptyLatLng: any;
    smallPolygon;
    unsortedPolygons = [];
    editablePolygons = [];
    newPolygons = [];
    editedPolygons = [];
    polygons = [];
    originalPolygons = [];
    editedOriginals = [];
    addedPolygons = [];
    polygonCoords = [];
    boundaryCenter;
    fieldBounds = [];
    polygonInteriors = [];

    showOptions = false;
    hideAnalysisLabel = false;

    selectedMapsItem: any;
    selectedFarmMapsItem: SelectedFarmMapsItemModel;

    selectedFarmMapsItemObj: any;

    /** Farm-level recache, busy flag + the last dialog selection so the overlay can be reloaded
     *  afterwards (same shape overlayMapItem already takes). See recacheFarmOverlay(). */
    farmRecaching = false;
    private lastSelectedFarmMapsItem: any = null;

    /** Whether this user may recache from the farm overlay box -- role only. Split out from the
     *  "is there a farm overlay to show at all" check below so the restyled box's own layout (text,
     *  divider, Close) matches the new /maps UI for every user, and only the Recache half of it is
     *  gated by role -- same as the new UI's persistent caption and panel bar. */
    get canRecacheFarmOverlay(): boolean {
        return this.helper.doesUserHaveRole('RecacheAnalysisMapView');
    }

    /** Whether there's a farm overlay applied at all, independent of role -- decides which box
     *  layout renders (restyled vs. the original plain one used when nothing is selected). */
    get hasFarmOverlayData(): boolean {
        return !!this.selectedFarmMapsItemObj?.length;
    }

    analysisTypesAvailable: MapsTypesAvailabilityModel[] = [];
    selectedMapTitleDetails: AnalysisTitleModel;
    selectedDate: any;

    editablePolygon: google.maps.Polygon;
    editableCircle: google.maps.Circle;
    circle;
    polygon;
    originalPolygon: google.maps.Polygon;

    mapsFarmImageryDto: MapsFarmImageryDto;

    images = [];
    image;
    overlay;
    overlayedAnalysis = [];
    fieldLegends: FieldLegend[] = [];
    farmLegends: FarmLegend[] = [];
    fieldLegends1: FieldLegend[] = [];
    aType

    opacity = 1.0;

    @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
    infoContent = '';

    markerLabelType: string = '';

    public iconUrl = {
        urlNewTemp: '../../assets/icons/new_pin_updated.png',
        urlMarker: '../../assets/icons/marker_pin.png',
        urlSoftVirualConsultant: '../../assets/icons/virtual_consultant_pin.png',
        urlSoftTissue: '../../assets/icons/soft_tissue_pin.png',
        urlSoil: '../../assets/icons/soil_pin.png',
        urlWater: '../../assets/icons/water_pin.png',
        urlDisease: '../../assets/icons/disease_pin.png',
        urlPest: '../../assets/icons/pest_pin.png',
        urlFertilizer: '../../assets/icons/fertilizer_pin.png',
        urlYieldEst: '../../assets/icons/yield_estimations_pin.png',
        urlNester: '../../assets/icons/Ntester_pin.png',
        urlSoilCompleted: '../../assets/icons/soil_completed.png',
        urlSoftTissueCompleted: '../../assets/icons/soft_tissue_completed.png',
        urlFieldInspection: '../../assets/icons/field_inspection_pin.png'
    }

    icon: google.maps.Icon = {
        url: this.iconUrl ? this.iconUrl.urlNewTemp : this.iconUrl.urlMarker,
        scaledSize: new google.maps.Size(24, 29)
    };
    markerOptions: google.maps.MarkerOptions = {
        icon: '#'
    };

    labelOptions = {
        color: 'white',
        fontFamily: environment.theme.fontFamily || '',
        fontSize: '14px',
        fontWeight: 'bold',
        text: ''
    }

    pinLabelOptions = {
        color: 'white',
        fontFamily: environment.theme.fontFamily || '',
        fontSize: '14px',
        fontWeight: 'bold',
        text: '',
    }


    pinMarker = {
        id: -1,
        position: { lat: -1, lng: -1 },
        title: '',
        farmName: '',
        label: this.pinLabelOptions,
        options: google.maps.MarkerOptions = {
            icon: google.maps.Icon = {
                url: this.icon,
                scaledSize: new google.maps.Size(24, 29)
            }
        }
    };


    fieldBoundaryColor: string = environment.google.mapConfig.polygonStrokeColour;
    fieldBoundaryEditColor: string = environment.google.mapConfig.polygonEditingStrokeColour;
    themeName: string = environment.theme.title;

    polygonOptions: google.maps.PolygonOptions = {
        strokeColor: this.fieldBoundaryColor,
        strokeWeight: 4,
        fillOpacity: 0.0
    }

    singlePolygon: google.maps.PolygonOptions = {
        strokeColor: this.fieldBoundaryColor,
        strokeWeight: 4,
        fillOpacity: 0.0
    }

    marker = {
        id: -1,
        position: { lat: -1, lng: -1 },
        title: '',
        farmName: '',
        label: this.labelOptions,
        type: ''
    };

    options: google.maps.MapOptions = {
        mapTypeControl: false,
        mapTypeId: 'hybrid',
        zoomControl: true,
        minZoom: 4,
        mapId: 'DEMO_MAP_ID',
        scrollwheel: true,
        disableDoubleClickZoom: true,
        streetViewControl: false,
        restriction: {
            latLngBounds: {
                east: 180,
                north: 85,
                south: -85.05115,
                west: -180
            },
            strictBounds: true
        }
    }

    // drawingManager: google.maps.drawing.DrawingManager;

    isDrawingMode: boolean = false;
    drawnPoints: google.maps.LatLngLiteral[] = [];
    originalDrawnPoints: google.maps.LatLngLiteral[] = [];
    originalCircleCenter: google.maps.LatLngLiteral;
    originalCircleRadius: number;
    newFieldName: string = '';
    previewLine: google.maps.Polyline = null;

    drawingType: 'polygon' | 'circle' | null = null;
    circleCenter: google.maps.LatLngLiteral = null;
    previewCircle: google.maps.Circle = null;
    isDraggingCircle: boolean = false;
    circleCenterMarker: google.maps.marker.AdvancedMarkerElement = null;

    circleListeners: google.maps.MapsEventListener[] = [];

    public tracking = "";
    public labels = "";
    public rainfall = "";

    public farm = "";
    public field = "";
    public edit = "";
    public closeEdit = "";
    public drawing = "";
    public busyEditing = "";
    public editingAll = "";
    public area = "";
    public closeAddField = "";

    public notifications: boolean = true;

    public isOpen: boolean = false;
    finishedLoading: boolean = false;
    public isCurentlyOpen: boolean = false;
    selectedFarm: any;
    filteredFarms: Farm[];
    farms: Farm[];
    farmIndex: number = -1;
    fields = [];
    fieldObject: { id: number, name: string } = { id: 0, name: '' };

    selectedAnalysis;
    analysisDates;

    previewPolyline: google.maps.Polyline = null;
    previewPolygon: google.maps.Polygon = null;

    drawnMarkers: google.maps.marker.AdvancedMarkerElement[] = [];

    countries: Countries[] = [];
    delete: boolean = false;
    noBoundary: boolean = false;

    loadingPins: boolean = false;

    saveFields: boolean = false;
    saveEditedField: boolean = false;
    saveArea: boolean = false;
    editing: boolean = false;
    editingFields: boolean = false;
    // stillDrawing: boolean = false;
    changed: boolean = false;
    optionsReached: boolean = false;
    farmOptionsReached: boolean = false;
    oneAction: boolean = false;
    action: any = "";
    splitField: boolean = false;
    errorUpdating: boolean = false;
    splitFieldId;
    splitFieldName;
    fieldName = "";
    map;
    selectedFarmIndex: number = -1;
    selectedFieldIndex: number = -1;

    variance: number;
    polygonIsArray: boolean = false;
    polygonArray = [];
    subscription;

    constructor(
        private auth: AuthService,
        public nav: NavBarComponent,
        public base: Base,
        public farmManagementService: FarmManagementService,
        public analysisManagementService: AnalysisManagementService,
        public rainfallService: RainfallService,
        public boundaryManagementService: BoundaryManagementService,
        public mappingService: MappingService,
        private _bottomSheet: MatBottomSheet,
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        private router: Router,
        public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        public helper: HelperService,
        public translate: TranslateService,
        private spinner: NgxSpinnerService,
        private rendererFactory: RendererFactory2,
        public pinManagerService: PinManagerService,
        public projectTitle: Title,
        private fieldDetailsService: FieldDetailsService,
        private vardaService: VardaService,
        private featureFlagsService: FeatureFlagsService,
        private weatherForecastService: WeatherForecastService,
        private weatherStationService: WeatherStationService,
        private syncService: SyncService,
        private tenantService: TenantService,
        public droneSurveys: DroneSurveyService,
        public tileOverlay: MapsTileOverlayService,
    ) {

        this.renderer = rendererFactory.createRenderer(null, null);

        this.nav.toggleLoading(false);

        this.tracking = this.translate.instant("MAPPING.TRACKING");
        this.labels = this.translate.instant("MAPPING.LABELS");
        this.rainfall = this.translate.instant("MAPPING.RAINFALL");
        this.farm = this.translate.instant("MAPPING.ADD-FARM");
        this.field = this.translate.instant("MAPPING.ADD-FIELD");
        this.edit = this.translate.instant("MAPPING.EDIT-FIELDS");
        this.closeEdit = this.translate.instant("MAPPING.CLOSE-EDIT");
        this.drawing = this.translate.instant("MAPPING.DRAWING");
        this.busyEditing = this.translate.instant("MAPPING.EDITING");
        this.editingAll = this.translate.instant("MAPPING.EDITING-ALL");
        this.selectedAnalysis = this.translate.instant("HISTORY.FILTER-ALL");
        this.area = this.translate.instant("MAPPING.ADD-AREA");
        this.closeAddField = this.translate.instant("MAPPING.STOP-DRAWING");

        this.analysisDates = this.startDate + " " + this.translate.instant("HISTORY.FILTER-TO") + " " + this.endDate;

        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);

        // this.drawingManager = new google.maps.drawing.DrawingManager({
        //     drawingControl: false,
        // });
        //
        // this.drawingManager.setMap(null);

        if (this.mobileQuery.matches) {
            this.flex1 = 50;
            this.flex2 = 50;
        }

        this.userId = this.helper.getUserId();

        this.nav.tenantId$.subscribe(id => {
            if (id != null) {
                this.mapping = true;
                this.tenantId = id;
                this.nav.toggleLoading(true);
                navigator.geolocation.clearWatch(this.watchId);
                this.markers.splice(this.markers.indexOf(this.trackingMarker), 1);
                this.geoJsonObject = [];
                this.markers = [];
                this.newSavedPins = [];
                this.images = [];
                this.polygons = [];
                this.selectedFarm = '';


                if (this.animationState == 'out') {
                    this.animationState = 'in';
                }

                this.selectedFarmIndex = -1;


                this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
                    if (farms != null) {
                        farms.sort((a, b) => a.name.localeCompare(b.name));
                        this.filteredFarms = farms;
                        this.farms = farms;
                        this.farmSubjects.next(farms);
                        let jsonFarms = JSON.stringify(farms);
                        sessionStorage.setItem("farms", jsonFarms);
                        this.nav.toggleLoading(false);
                        let firstTimeLogin = localStorage.getItem('firstTimeLogin')

                        if(sessionStorage.getItem("roles") && (firstTimeLogin?.includes('order') || firstTimeLogin?.includes('submission'))) {
                            this.router.navigateByUrl(localStorage.getItem('firstTimeLogin'));
                        }
                    }
                    if (farms?.length == 0) {
                        this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
                    }
                });


                this.showOverlay = false;
                this.isTrackingActive = false;
                if (this.tenantId !== undefined && this.tenantId !== null) {
                    setTimeout(() => {
                        this.rainfallService.getRainMeters(id).subscribe((rainMeters) => {
                            this.rainMeters = rainMeters;
                        })
                    }, 1000);

                }
            }
            this.zoomOutOnTenantChange();
        })

        this.base.fetchFarm().subscribe(farm => {

            this.zoom = this.maxMapZoom;
            if (this.farmId == -1) {
                if (farm.farmId != null) {
                    this.farmId = farm.farmId;

                    this.farmName = farm.farmName;
                    this.base.fetchFilter().subscribe(filter);

                    this.mapping = false;
                    this.farmManagementService.getFarmBoundingBox(farm.farmId).subscribe((boundingBox) => {

                        this.farmBounds = new google.maps.LatLngBounds();
                        this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                        this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));
                    });
                    this.overlayBoundary(this.farmId, this.farmName, 0);
                }
            }
        });
    }

    viewFieldDetails(fieldId, farm: Farm) {
      this.fieldDetailsService.viewFieldDetails(fieldId, this.tenantId).subscribe({
        next: (res) => {
          // Refresh the currently active farm's fields on the map
          this.clearMap();
          this.overlayBoundary(this.farmId, this.farmName, null);
        }
      });
    }

    createMarkerWithLabel(labelText: string): HTMLElement {
        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'center';

        // const img = document.createElement('img');
        // img.src = iconUrl;
        // img.style.width = '24px';
        // img.style.height = '29px';

        const label = document.createElement('span');
        label.textContent = labelText;
        label.style.fontFamily = environment.theme.fontFamily || 'sans-serif';
        label.style.fontSize = '12px';
        label.style.fontWeight = 'bold';
        label.style.color = 'white';

        // container.appendChild(img);
        container.appendChild(label);
        return container;
    }

    createMarkerContent(iconUrl: string): HTMLElement {
        const img = document.createElement('img');
        img.src = iconUrl;
        img.style.width = '24px';
        img.style.height = '29px';
        return img;
    }

    createCircleMarkerContent(scale = 8, fillColor = '#FF6B00', fillOpacity = 1, strokeColor = '#000000', strokeWeight = 2) {
        const size = scale * 2;
        const container = document.createElement('div');
        container.style.transform = 'translate(0%, 50%)';
        container.style.cursor = 'pointer';
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', `${size}`);
        svg.setAttribute('height', `${size}`);
        svg.setAttribute('viewBox', `0 0 ${size} ${size}`);
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', `${scale}`);
        circle.setAttribute('cy', `${scale}`);
        circle.setAttribute('r', `${scale - strokeWeight}`);
        circle.setAttribute('fill', fillColor);
        circle.setAttribute('fill-opacity', `${fillOpacity}`);
        circle.setAttribute('stroke', strokeColor);
        circle.setAttribute('stroke-width', `${strokeWeight}`);
        svg.appendChild(circle);
        container.appendChild(svg);
        return container;
    }

  placeMarker($event: google.maps.MapMouseEvent, fieldId, fieldName, dblClick: boolean) {
      if(dblClick) {
          if(fieldId) {
              this.fieldId = fieldId;
              this.fieldName = fieldName;
              this.optionsReached = true;
              let latLng = $event.latLng.toJSON();
              let marker = {
                  id: this.tmpId,
                  position: { lat: latLng.lat, lng: latLng.lng },
                  title: 'pin #' + this.pinCounter++,
                  content: this.createMarkerContent('../../assets/icons/new_pin_updated.png')
              };

              let newPin = {
                  id: this.tmpId,
                  description: 'string',
                  fieldId: this.fieldId,
                  fieldName: this.fieldName,
                  lat: latLng.lat,
                  lng: latLng.lng,
                  userId: this.helper.getUserId(),
                  tenantId: this.tenantId
              }

              this.newSavedPinsData.push(newPin);

              this.openedWindow = this.tmpId;

              this.tmpId--;

              this.markers.push(marker);
                this.isPinMarkersVisible = true;
                if (!this.selectedPinType) {
                    this.selectedPinType = { id: null, name: 'Dropped Pins' } as PinType;
                }
          } else {
              this.openSnackBar(this.translate.instant("MAPPING.OUTSIDE-FARM-PIN-DROP"), this.translate.instant("SNACKBAR.DISMISS"));
          }
      } else {
          //console.log("placeMarker called from single click: ", { fieldId, fieldName, dblClick })
          this.optionsReached = false;
          this.boundaryClick(fieldId, fieldName);
      }

    // this.getDynamicPins(this.tenantId, fieldId, latLng.lat, latLng.lng, true, marker.title, null);
  }


    openWindow(id) {
        this.openedWindow = id;
    }

    // open close map-menu-circular
    openOptions() {
        this.isOpen = !this.isOpen;
    }

    onScrollCloseOptions(): void {
        if(this.selectedFarmIndex && this.filteredFarms[this.selectedFarmIndex]) {
            this.filteredFarms[this.selectedFarmIndex].showOptions = false;
            this.selectedFarmIndex = -1;
        }
    }


    openMaps(): void {
        if (!this.mapsAlreadyOpen) {
            this.mapsAlreadyOpen = true;
            let mapsTypesAvailabilityDto: MapsTypesAvailabilityDto = { farmId: this.farmId, fieldId: null }
            this.analysisManagementService.getMapsTypesAvailability(mapsTypesAvailabilityDto).subscribe(availableTypes => {

                let mapTypesData = [];
                availableTypes.forEach(availableTypeobj => {
                    let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
                        type: availableTypeobj.type,
                        available: availableTypeobj.available,
                        alias: availableTypeobj.alias,
                        displayOrder: 1,
                        selected: false
                    };
                    mapTypesData.push(mapsTypesAvailabilityModel);
                });
                this.analysisTypesAvailable = mapTypesData;

                const dialogRef = this.dialog.open(MapDataFarmComponent, {
                    data: {
                        farmNameHeader: this.farmName,
                        analysis: mapTypesData,
                        farmID: this.farmId,
                        fieldID: this.fieldId,
                        date: this.analysisDates,
                        previousValue: this.previousValue,
                    },
                    autoFocus: false,
                    panelClass: 'no-padding-dialog',
                });
                dialogRef.afterClosed().subscribe(result => {

                    if (result !== undefined) {
                        this.selectedMapsItem = result.selectedItem;
                        this.previousValue = result.lastSelectedType;
                        this.variance = result.lastSelectedVariance;
                        if (result.selectedItem.type != null) {
                            this.selectedAnalysis = result.selectedItem.type;
                            this.analysisDates = result.selectedItem.datePerformed;
                            if (result.selectedItem.analysisId !== null) {
                                this.activeHistoryId = result.selectedItem.analysisId;
                                this.overlayMapItem(result?.selectedItem);

                                setTimeout(() => {
                                    this.nav.toggleLoading(false);
                                }, 3000);
                            }
                        }
                    }
                    this.mapsAlreadyOpen = false;
                });
            });
        }
    }

    removeAnalysis() {
        this.images.splice(0, this.images?.length);
        this.farmLegends = [];
        this.hideAnalysisLabel = true;
    }

    /** Farm-level recache: one recacheAnalysis call per field currently shown
     *  (selectedFarmMapsItemObj already carries a real analysisId per field, from getFarmImagery).
     *  Not a single server-side batch operation. Each call queues a recache via the same RabbitMQ
     *  path the bulk/by-type mechanism already uses, rather than a direct synchronous call -- a
     *  successful response means "request accepted", not "field recached". Reports an honest
     *  accepted/rejected count rather than one pass/fail, matching how the dataloader itself
     *  handles partial failure. There is nothing to poll yet, so this does not reload the overlay;
     *  it only reflects the new recache once revisited later. */
    recacheFarmOverlay(): void {
        if (!this.selectedFarmMapsItemObj?.length || this.farmRecaching) { return; }
        const analysisIds = this.selectedFarmMapsItemObj.map(item => item.analysisId).filter(Boolean);
        if (!analysisIds.length) { return; }

        this.farmRecaching = true;
        // Three outcomes, not two: a 409 means this exact analysisId is already queued or
        // processing elsewhere, which is worth saying explicitly -- folding it into "queued" would
        // hide that the dedupe actually did something, and folding it into "failed" would wrongly
        // read as something going wrong.
        const calls: Observable<'queued' | 'inProgress' | 'failed'>[] = analysisIds.map((analysisId: number) =>
            this.analysisManagementService.recacheAnalysis(analysisId).pipe(
                map(() => 'queued' as const),
                catchError(err => of(err?.status === 409 ? ('inProgress' as const) : ('failed' as const)))
            )
        );
        forkJoin(calls).subscribe((results: ('queued' | 'inProgress' | 'failed')[]) => {
            this.farmRecaching = false;
            this._snackBar.open(summariseFarmRecacheResults(results), 'Dismiss', { duration: 6000 });
        });
    }

    clearPins(){
        if(this.isPinMarkersVisible){
                for (let i = 0; i < this.markers.length; i++) {
                if (this.markers[i].type == 'pin' || this.markers[i].type !== 'labelPin') {
                    this.markers.splice(i, 1);
                    i--;
                }
            }
        this.newSavedPins = [];
        this.isPinMarkersVisible = false;
        this.pinsCalled = false;
    }       
   }


    public overlayMapItem(selectedItem) {
        this.nav.toggleLoading(true);
        this.lastSelectedFarmMapsItem = selectedItem;

         this.selectedMapTitleDetails = {
            date: this.selectedMapsItem.date,
            type: this.selectedMapsItem.type,
            propertyTypeId: this.selectedMapsItem.propertyTypeId,
            propertyTypeName: this.selectedMapsItem.propertyTypeName
         }


        if (this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase()) && (!this.selectedMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()))) {
            this.selectedMapTitleDetails.type = this.selectedMapsItem.type;
            this.selectedDate = dayjs(selectedItem.date).format('YYYY-MM-DD');
            this.hideAnalysisLabel = false;

        } else if (this.selectedMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase())) {
            this.selectedMapTitleDetails = this.selectedMapsItem.type;
            this.selectedDate = dayjs(selectedItem.date).format('YYYY');
            this.hideAnalysisLabel = false;
        } else {
            this.selectedMapTitleDetails.type = this.selectedMapsItem.type;
            this.selectedMapTitleDetails.propertyTypeName = this.selectedMapsItem.propertyTypeName;
            this.selectedDate = dayjs(selectedItem.date).format('YYYY');
            this.hideAnalysisLabel = false;
        }


        if (this.mapsFarmImageryDto) {
            if (selectedItem.propertyTypeId !== this.mapsFarmImageryDto.propertyTypeId || selectedItem.propertyTypeId == null) {
                if(this.images){
                    this.images.splice(0, this.images?.length);
                }
                // this.images.splice(0, this.images.length);
            }
        }
        this.mapsFarmImageryDto = {
            date: selectedItem.date,
            farmId: this.farmId,
            variance: this.variance,
            type: selectedItem.type,
            propertyTypeId: selectedItem.propertyTypeId,
            pageSize: 25,
            pageNumber: 1
        };
        this.analysisManagementService.getFarmImagery(this.mapsFarmImageryDto).subscribe((farmOverlayImages => {

            this.selectedFarmMapsItemObj = farmOverlayImages;

            farmOverlayImages.forEach(farmOverlayImage => {

                this.analysisManagementService.getBoundingBox(farmOverlayImage.analysisId, farmOverlayImage.propertyTypeId).subscribe(boundingBox => {

                    let bounds = new google.maps.LatLngBounds();
                    bounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                    bounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));

                    //@ts-ignore
                    let url = farmOverlayImage.mapUrl;
                    // console.log(url)
                    // this.analysisManagementService.getImageAsBlob(url).subscribe(response => {
                    //     console.log(response)
                    //     let typedArray = new Uint8Array(response);
                    //     let base64String = this.arrayBufferToBase64(typedArray);
                    //     let image = 'data:image/jpg;base64, ' + base64String;


                    // });

                    let object = { image: url, bounds: bounds, fieldId: this.fieldId };

                    this.images.push(object);

                    setTimeout(() => {
                        this.nav.toggleLoading(false);
                    }, 2500);
                });
            })

            /////////////////// Get Legend ///////////////////////
            this.farmLegends = [];
            if ((this.selectedMapsItem.mapUrl !== null && !this.selectedMapsItem.type.toLowerCase().includes('satellite')) || this.selectedMapsItem.type.toLowerCase().includes('fixed')) {

                let mapsFarmImageryLegendDto: MapsFarmImageryLegendDto = {
                    farmId: this.farmId,
                    propertyTypeId: selectedItem.propertyTypeId,
                    date: selectedItem.date,
                    type: selectedItem.type,
                };

                this.analysisManagementService.getMapsFarmImageryLegend(mapsFarmImageryLegendDto).subscribe((farmLegendObj => {

                    farmLegendObj.forEach(item => {

                        let farmLegend: FarmLegend = {
                            value: item.value,
                            area: item.area,

                            id: item.id,
                            colour: farmLegendObj.colour,
                            lastModified: item.lastModified,
                            maxValue: item.maxValue,
                            minValue: item.minValue,
                            textValue: item.textValue,

                        };

                        if (item.textValue == null || item.textValue == 'null') {

                            if (item.maxValue != 1000000) {
                                farmLegend.value = parseFloat(item.minValue.toFixed(2)) + ' - ' + parseFloat(item.maxValue.toFixed(2));
                            } else {
                                farmLegend.value = '> ' + parseFloat(item.minValue.toFixed(2));
                            }
                        } else {
                            farmLegend.value = item.textValue;
                        }

                        farmLegend.colour = item.colour;
                        farmLegend.area = item.area;

                        this.farmLegends.push(farmLegend);
                    })
                }))
            }
        }));
    }

    arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    ngOnInit(): void {
        // Drone imagery backdrop. TenantService is a root BehaviorSubject
        // seeded from sessionStorage, so this covers both the initial load and
        // every tenant switch, and distinctUntilChanged makes a re-selection of
        // the same tenant a no-op.
        // If the cookie cannot be renewed, drop the imagery rather than leave
        // tiles silently failing to draw.
        this.droneAccessSub = this.droneSurveys.accessLost$.subscribe(() => {
            this.tileOverlay.detach();
            this.droneSurveys.surveys.set([]);
        });

        this.droneTenantSub = this.tenantService.currenttenantId.subscribe(id =>
            this.loadDroneOverlay(id ? +id : null)
        );

        this.isWeatherForecastEnabled = this.featureFlagsService.isEnabled('weather_forecast_feature');
        let firstTimeLogin = localStorage.getItem('firstTimeLogin')
        if(!firstTimeLogin) {
          setTimeout(() => {
            this.finishedLoading= true;
        }, 100);

            sessionStorage.removeItem('selectedFarmMapsItem');

            // this.setLastSelectedFarm();

            this.hideAnalysisLabel = true;
            this.zoom = this.maxMapZoom;

            // this.checkIfTenantHasFarms();

            this.nav.toggleLoading(true);
            setTimeout(() => {
                this.setLastSelectedFarm();
                this.nav.toggleLoading(false);
            }, 2000);


            if (this.farmId ! == null) {
                this.overlayBoundary(this.farmId, this.farmName, 0);
                this.focusBoundingBox();
            }
        }

    }

    ngOnDestroy(): void {
        this.droneTenantSub?.unsubscribe();
        this.droneAccessSub?.unsubscribe();
        // A tab left open should not keep refreshing access to imagery nobody
        // is looking at.
        this.droneSurveys.stopRenewingTileAccess();
        // The overlay service is root-scoped and outlives this component, so
        // do not leave an ImageMapType attached to a map being torn down.
        this.tileOverlay.detach();
    }

    /** True when the tenant has drone imagery, so the fade control shows. */
    get droneOverlayAvailable(): boolean {
        return this.droneSurveys.surveys().length > 0;
    }

    /**
     * Load and attach the tenant's drone imagery, or detach if it has none.
     *
     * Map access is deferred with setTimeout because the GoogleMap instance is
     * not ready on the change-detection pass that triggers this.
     */
    private loadDroneOverlay(tenantId: number | null): void {
        this.droneSurveys.loadSurveys(tenantId).subscribe(surveys => {
            setTimeout(() => {
                const map = this.agmMap?.googleMap;
                if (!map) return;
                if (surveys.length) {
                    this.tileOverlay.attach(map, surveys, this.droneOverlayOpacity);
                } else {
                    this.tileOverlay.detach();
                }
            });
        });
    }

    droneOverlayOpacity = 1;

    onDroneOpacityInput(event: Event): void {
        this.droneOverlayOpacity = Number((event.target as HTMLInputElement).value);
        this.tileOverlay.setOpacity(this.droneOverlayOpacity);
    }

    ngAfterViewInit() {
        // If lat long needs to be checked as you navigate - debug
        // this.agmMap.centerChanged.subscribe(() => {
        //     const center = this.agmMap.getCenter();
        //     const zoom = this.agmMap.getZoom();
        // });
    }

    

    overlayBoundaryForSelectedFarm(id: number, farmName: string, fieldCount: number, farmSize: number,field: any, buttonClicked?: boolean) {
        this.farmId = id;
        this.getMaps();
        this.mapping = false;
        this.pinCounter = 0;
        if (fieldCount > 0 && farmSize > -1) {
            if(buttonClicked) {
                if(id === this.activeId) {
                    this.farmOpened = !this.farmOpened;
                } else {
                    this.farmOpened = true;
                }

                if (this.saveFields || this.isDrawingMode || this.editing || this.editingFields) {

                    this.openSnackBar(this.translate.instant("MAPPING.FINISH-EDITING"), this.translate.instant("SNACKBAR.DISMISS"));
                } else if (this.openVardaBoundary && this.vardaField?.getPath()) {
                    this.openSnackBar(this.translate.instant("MAPPING.VARDA-BOUNDARY"), this.translate.instant("SNACKBAR.DISMISS"));
                } else if (this.nav.isLoading) {
                    this.openSnackBar(this.translate.instant("MAPPING.FINISH-LOADING"), this.translate.instant("SNACKBAR.DISMISS"));
                } else {
                    this.clearMap();
                    this.weatherForecasts = [];
                    this.showWeatherCard = false;
                    this.farmManagementService.getFarmBoundingBox(id).subscribe({
                        next: boundingBox => {
                            this.farmBounds = new google.maps.LatLngBounds(
                                new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1),
                                new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2)
                            );
                            this.overlayBoundary(id, farmName, field?.id);
                            this.noBoundary = false;

                            setTimeout(() => this.nav.toggleLoading(false), 1500);
                        },
                        error: () => this.nav.toggleLoading(false)
                    });

                    if(this.openVardaBoundary && !this.vardaField?.getPath()) {
                        this.openVardaBoundary = false;
                    }
                }
            } else {
                this.overlayBoundary(id, farmName, field?.id);
                setTimeout(() => this.nav.toggleLoading(false), 1500);
            }
        } else {
            // Empty farm handling
            this.clearMap();
            this.initializeEmptyFarm(id);
            this.clearPreviousFarmData();
            this.startGeolocationTracking();
            setTimeout(() => this.nav.toggleLoading(false), 1000);
        }
    }

    private initializeEmptyFarm(id: number) {
        this.noBoundary = true;
        this.activeId = this.farmId = id;
        [this.polygons, this.markers, this.images] = [[], [], []];
    }

    private clearPreviousFarmData() {
        this.fields = [];
        this.centerMarkers = [];
        this.farmLegends = [];
        this.showOverlay = false;
        this.fieldCounter = -1;
    }

    private startGeolocationTracking() {
        if (!navigator.geolocation) {
            this.handleGeolocationUnsupported();
            return;
        }

        navigator.geolocation.clearWatch(this.watchId);
        this.zoom = this.minMapZoom;
        this.isTrackingActive = true;

        this.watchId = navigator.geolocation.watchPosition(
            position => {}, // Empty callback - showTrackingPosition commented out
            error => this.handleGeolocationError(error)
        );
    }

    private handleGeolocationError(error: GeolocationPositionError) {
        if (error.code === error.PERMISSION_DENIED) {
            navigator.geolocation.clearWatch(this.watchId);
            const trackingIndex = this.markers.indexOf(this.trackingMarker);
            if (trackingIndex > -1) this.markers.splice(trackingIndex, 1);
        }
        this.isTrackingActive = false;
        this.zoom = this.maxMapZoom;
    }

    private handleGeolocationUnsupported() {
        alert("Geolocation is not supported by this browser.");
        this.zoom = this.maxMapZoom;
    }

        private clearMap(){
            this.noBoundary = true;
            //  this.activeId = id;
            //  this.farmId = id;
             this.polygons = [];
             this.markers = [];
             this.images = [];
        }


    // OPTIMIZED overlayBoundary METHOD
    overlayBoundary(id: number, farmName: string, fieldId) {
        this.mapping = false;
        this.zoom = this.maxMapZoom;

        if (this.isTrackingActive) {
            this.toggleTracking();
        }

        this.farmId = id;
        this.farmName = farmName;
        sessionStorage.setItem('lastFarmName', this.farmName);
        this.activeId = id;
        sessionStorage.setItem('lastFarmId', String(this.activeId));
        this.centerMarkers = [];
        this.images = [];

        if (!this.checkCircle) {
            this.polygons = [];
            this.markers = [];
        }

        this.showTracking = false;
        this.isTrackingActive = false;
        this.showOverlay = true;
        this.fieldCounter = -1;

        sessionStorage.removeItem("histories");

        // Optimized polygon processing with RxJS operators
        this.nav.toggleLoading(true);
        
        this.farmManagementService.getFarmPolygon(id).subscribe({
            next: (fields) => {
                this.fields = fields.map(field => ({
                    ...field, 
                    ...this.processFieldCoordinates(field)
                }));
                this.buildPolygonsFromProcessedFields(this.fields);
                this.handleCircleCheck(fieldId);
                this.processFieldMarkers(id, farmName);
                this.nav.toggleLoading(false);
            },
            error: () => this.nav.toggleLoading(false)
        });
    }

    private processFieldCoordinates(field: any): { fieldId: number; polygons: google.maps.LatLngLiteral[][] } {

        if (!field.boundry?.features?.[0]?.geometry?.coordinates) {
            return { fieldId: field.id, polygons: [] };
        }
        
        const coordinates = field.boundry.features[0].geometry.coordinates;
        const polygons = [];

        coordinates.forEach((coordinate) => {
            if (coordinate.length === 1) {
                // Single polygon
                const polygon = coordinate[0].map(latLng => ({
                    lat: Number(latLng[1]),
                    lng: Number(latLng[0])
                }));
                polygons.push(polygon);
            } else if (coordinate[0].length === 2) {
                // Multiple coordinates
                const polygon = coordinate.map(coord => ({
                    lat: Number(coord[1]),
                    lng: Number(coord[0])
                }));
                polygons.push(polygon);
            } else {
                // Complex multi-polygon
                coordinate.forEach(coord => {
                    const polygon = coord.map(latLng => ({
                        lat: Number(latLng[1]),
                        lng: Number(latLng[0])
                    }));
                    polygons.push(polygon);
                });
            }
        });
        
        return { fieldId: field.id, polygons };
    }

    private buildPolygonsFromProcessedFields(processedFields: any[]) {
        this.unsortedPolygons = [];

        processedFields.forEach(field => {
            const fieldPolygon = {
                id: field.fieldId,
                points: field.polygons.length === 1 ? field.polygons[0] : field.polygons,
                size: field.size,
                fieldName: field.name,
                changed: false
            };
            this.unsortedPolygons.push(fieldPolygon);
        });

        if (!this.checkCircle) {
            this.unsortedPolygons.sort((a, b) => b.size - a.size);
            this.polygons.push(...this.unsortedPolygons.filter(p =>
                !this.polygons.some(existing => existing.id === p.id)
            ));
            this.unsortedPolygons = [];
        }
    }

    private handleCircleCheck(fieldId: number) {
        if (this.checkCircle && this.polygons.length > 0) {
            this.processFieldIntersections(fieldId);
        } else {
            this.finalizePolygonProcessing();
        }
    }

    private processFieldIntersections(fieldId: number) {
        const targetField = this.polygons.find(p => p.id === fieldId);
        if (!targetField) {
            this.finalizePolygonProcessing();
            return;
        }
        // Simplified intersection processing - implement complex logic if needed
        this.finalizePolygonProcessing();
    }

    private finalizePolygonProcessing() {
        if (this.farmBounds) {
            this.agmMap.zoom = this.minMapZoom;
            this.agmMap.fitBounds(this.farmBounds);
        }
    }

    private processFieldMarkers(id: number, farmName: string) {
        if (!this.checkCircle) {
            this.farmManagementService.getFarmFields(id).subscribe((fields) => {
                if (fields != null) {
                    this.fieldSubjects.next(fields);
                    sessionStorage.setItem("fields", JSON.stringify(fields));
                    this.fieldBounds = [];

                    fields.forEach(field => {
                        this.bounds = new google.maps.LatLngBounds();
                        this.bounds.extend(new google.maps.LatLng(field.lat1, field.lng1));
                        this.bounds.extend(new google.maps.LatLng(field.lat2, field.lng2));

                        this.fieldBounds.push({ bounds: this.bounds, fieldId: field.id });

                        const marker = {
                            id: field.id,
                            position: { lat: field.centroidLat, lng: field.centroidLng },
                            title: field.name,
                            farmName: farmName,
                            label: 'Test',
                            options: {
                                icon: { url: '#' }
                            },
                            type: 'labelPin',
                            content: this.createMarkerWithLabel(field.name)
                        };

                        this.markers.push(marker);
                        this.centerMarkers.push({
                            ...marker,
                            position: this.bounds.getCenter()
                        });
                        this.fieldCounter++;
                    });
                }

                this.base.fetchAnalysis().subscribe(analysis => {
                    if (analysis.histories?.length > 0) {
                        this.images = analysis.images;
                        this.overlayedAnalysis = analysis.histories;
                    }
                });
            });
        }
    }

    // labelClick() {
    //     this.router.navigate(['/field'], {state: {id: this.marker.id, farmName: this.marker.farmName, farmId: this.farmId}});
    // }


    infoClick(marker, fieldId, fieldName) {
        //console.log(marker, fieldId, fieldName)
        //console.log('infoClick called:', { marker, fieldId, fieldName });
        this.marker = marker;
        this.viewPinInfo = true;
        this.nav.toggleLoading(true);

        if(marker?.id <= 0) {
          this.openNewSavePinDialog(marker, fieldId, fieldName);
        } else {
          if (this.marker.type == 'labelPin') {
              this.optionsReached = false;
            this.boundaryClick(fieldId, fieldName);
          } else {
              this.openExistingPinOptions();
          }
        }

    }

  openNewSavePinDialog(marker, fieldId, fieldName) {
      this.nav.toggleLoading(false);
      let pinDetail = this.newSavedPinsData.find(x => x.id == fieldId);
    const dialogRef = this.dialog.open(NewSavePinComponent, {

      data: {
        pinTypeId: marker.pinTypeId,
        lat: marker.position.lat,
        lng: marker.position.lng,
        date: dayjs().format(),
        farm: this.farmName,
        field: pinDetail.fieldName,
        fieldId: pinDetail.fieldId,
        userId: this.helper.getUserId(),
        creatingUser: marker?.creatingUser ?? '-',
        tenantId: this.tenantId
      }
    });

    dialogRef.afterClosed().subscribe(response => {

      // this.newSavedPin = result;

      if (response.option === 'remove') {
        this.markers = this.markers.filter(m => m?.type);
        this.optionsReached = false;
        this.pinCounter = 0;
      } else if(response?.option === 'save') {
        marker.creatingUser = response.pinMarker.userName + ' ' + response.pinMarker.userSurname
        this.optionsReached = false;

        if (response.pinMarker.pinTypeId == 1) {
          const dialogRef = this.dialog.open(MarkerPinComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          })
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
          })

        } else if (response.pinMarker.pinTypeId == 2) {

          const dialogRef = this.dialog.open(VirtualConsultantPinComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          })
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
          })

        } else if (response.pinMarker.pinTypeId == 3) {

          const dialogRef = this.dialog.open(SoftTissuePinSamplesComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
          });

        }
        else if (response.pinMarker.pinTypeId == 4) {

          const dialogRef = this.dialog.open(SoilPinSamplesComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
          });
        }
        else if (response.pinMarker.pinTypeId == 5) {

          const dialogRef = this.dialog.open(WaterPinComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
          });
        }
        else if (response.pinMarker.pinTypeId == 6) {

          const dialogRef = this.dialog.open(DiseasePinComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
          });
        }
        else if (response.pinMarker.pinTypeId == 7) {

          const dialogRef = this.dialog.open(PestPinComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);

          });
        }
        else if (response.pinMarker.pinTypeId == 8) {

          const dialogRef = this.dialog.open(YieldEstimationPinComponent, {
            data: {
              pinTypeId: response.pinMarker.pinTypeId,
              lat: response.pinMarker.lat,
              lng: response.pinMarker.lng,
              date: dayjs().format(),
              farm: this.farmName,
              field: pinDetail.fieldName,
              fieldId: pinDetail.fieldId,
              userId: this.helper.getUserId(),
              creatingUser: marker?.creatingUser ?? '-',
              tenantId: this.tenantId,
              pinId: response.pinMarker.id,
              pinDescription: response.pinMarker.description
            }
          });
          dialogRef.afterClosed().subscribe(response => {
            this.reloadMarker(response);
            this.nav.toggleLoading(false);
          });
        } else if (response?.isFieldInspection || response?.pinMarker?.pinTypeId == 10) {
          // Field Inspection pin saved — update icon on map and open form dialog
          this.nav.toggleLoading(false);
          marker.content = this.createMarkerContent(this.iconUrl.urlFieldInspection);
          if (response?.pinMarker?.id) {
            // Update the marker's id from the temporary negative value to the real server id
            // so subsequent clicks route to openExistingPinOptions instead of openNewSavePinDialog
            marker.id = response.pinMarker.id;
            marker.pinTypeId = 10;

            // Marker bookkeeping above must always run so the pin gets its real
            // server id. Only opening the report form is role-gated.
            if (!this.helper.canAccessFieldInspection()) {
              setTimeout(() => this.getNewSavedPins(), 300);
              return;
            }

            const inspectionDialogRef = this.dialog.open(FieldInspectionDialogComponent, {
              data: {
                pinId: response.pinMarker.id,
                fieldId: response.pinMarker.fieldId ?? pinDetail?.fieldId,
                tenantId: this.tenantId,
                farm: this.farmName,
                field: pinDetail?.fieldName,
                lat: response.pinMarker.lat,
                lng: response.pinMarker.lng,
                viewOnly: false,
                isNewInspection: true,
                cropDefinitions: undefined
              },
              width: '900px',
              maxWidth: '95vw',
              height: '88vh',
              maxHeight: '88vh',
              autoFocus: false
            });

            // Reload all markers after the dialog closes so the pin has the correct
            // server ID and pinTypeId — prevents it being treated as a new temp pin
            inspectionDialogRef.afterClosed().subscribe(() => {
              setTimeout(() => this.getNewSavedPins(), 300);
            });
          }
        }
      }
    });

  }

  reloadMarker(response){
    let newMarker = {
      id: response?.pinId ?? this.existingMarker?.id,
      position: {lat: response?.lat, lng: response?.lng},
      title: response?.pinDescription ?? this.existingMarker?.description,
      creatingUser: response?.creatingUser,
      pinTypeId: response.pinTypeId,
      content: this.createMarkerContent(this.setPinTypeIcon(response)),
    //   options: google.maps.MarkerOptions = {
    //     icon: google.maps.Icon = {
    //       url:  this.setPinTypeIcon(response),
    //       scaledSize: new google.maps.Size(24, 29)
    //     }
    //   },
      type: 'pin'
    };
    this.markers.forEach((marker, index)=> {
      if(marker?.position?.lat == response?.lat && marker?.position?.lng == response?.lng){
        this.markers.splice(index,1);
      }
    })
    this.markers.push(newMarker);
    this.newSavedPins.push(newMarker);

    if(this.isPinLabelsShowing) {
      this.setPinLabels();
    }
  }


    // labelClick(fieldId, fieldName,  $event: google.maps.MapMouseEvent) {
    //     this.boundaryClick(fieldId, fieldName, $event);
    // }

    boundaryClick(fieldId, fieldName) {
        if (this.selectedFarmMapsItemObj) {
            this.selectedFarmMapsItemObj.every(selectedFarmItem => {
                if (selectedFarmItem.fieldId === fieldId) {
                    this.selectedFarmMapsItem = {
                        analysisId: selectedFarmItem.analysisId,
                        propertyTypeId: selectedFarmItem.propertyTypeId,
                        type: selectedFarmItem.type,
                        datePerformed: selectedFarmItem.datePerformed,
                        propertyTypeName: selectedFarmItem.propertyTypeName,
                        mapUrl: selectedFarmItem.mapUrl,
                        fieldID: selectedFarmItem.fieldId,

                        alias: this.previousValue.alias,
                        displayOrder: this.previousValue.displayOrder,
                        available: this.previousValue.available,
                        selected: this.previousValue.selected
                    };
                }
                return true;
            });
        }

        //SetTimeout helps to ensure that the pin drop happens without routing to field
        setTimeout(() => {
            if (!this.optionsReached) {
                let fieldPolygons = [];
                for (let i = 0; i < this.polygons.length; i++) {
                    if (this.polygons[i].id == fieldId) {
                        fieldPolygons.push(this.polygons[i].points)
                    }
                }
                this.nav.toggleLoading(true);

                this.base.setAnalysis(this.overlayedAnalysis, this.images, fieldPolygons, this.polygons);


                if (this.selectedFarmMapsItem !== undefined) {
                    let farmObj = {
                        alias: this.selectedFarmMapsItem.alias,
                        analysisId: this.selectedFarmMapsItem.analysisId,
                        available: this.selectedFarmMapsItem.available,
                        datePerformed: this.selectedFarmMapsItem.datePerformed,
                        displayOrder: this.selectedFarmMapsItem.displayOrder,
                        fieldID: this.selectedFarmMapsItem.selected,
                        mapUrl: this.selectedFarmMapsItem.mapUrl,
                        propertyTypeId: this.selectedFarmMapsItem.propertyTypeId,
                        propertyTypeName: this.selectedFarmMapsItem.propertyTypeName,
                        selected: this.selectedFarmMapsItem.selected,
                        type: this.selectedFarmMapsItem.type,
                    }
                    let jsonFarmObj = JSON.stringify(farmObj);
                    sessionStorage.setItem('selectedFarmMapsItem', jsonFarmObj);
                }

                const env = environment as any;
                const isSouthernGateway = env.theme?.title === 'Southern Gateway' ||
                                         env.apiBaseUrl?.includes('southern-gateway') ||
                                         (env.environmentName && env.environmentName.includes('southern-gateway'));
                if (isSouthernGateway) {
                    forkJoin({
                        hasStation: this.weatherStationService.hasTenantWeatherStation(Number(this.tenantId)),
                        hasFms: this.syncService.hasTenantFmsData(Number(this.tenantId))
                    }).subscribe({
                        next: ({ hasStation, hasFms }) => {
                            if (hasStation || hasFms) {
                                this.router.navigate(['/field-dashboard-view', fieldId, 'analysis'], {
                                    queryParams: { farmId: this.farmId, tenantId: this.tenantId }
                                });
                            } else {
                                this.router.navigate(['/field'], {
                                    state: {
                                        id: fieldId,
                                        farmName: this.farmName,
                                        farmId: this.farmId,
                                        analysisTypes: this.selectedAnalysis,
                                        analysisDates: this.analysisDates,
                                        fieldName: fieldName,
                                    }
                                });
                            }
                        },
                        error: () => {
                            this.router.navigate(['/field'], {
                                state: {
                                    id: fieldId,
                                    farmName: this.farmName,
                                    farmId: this.farmId,
                                    analysisTypes: this.selectedAnalysis,
                                    analysisDates: this.analysisDates,
                                    fieldName: fieldName,
                                }
                            });
                        }
                    });
                } else {
                    this.router.navigate(['/field'], {
                        state: {
                            id: fieldId,
                            farmName: this.farmName,
                            farmId: this.farmId,
                            analysisTypes: this.selectedAnalysis,
                            analysisDates: this.analysisDates,
                            fieldName: fieldName,
                        }
                    });
                }
            }
        }, 400);

    }

    toggleTracking() {
        if (!this.showOverlay) {
            if (!this.isTrackingActive) {
                if (navigator.geolocation) {
                    this.zoom = this.minMapZoom;
                    this.isTrackingActive = true;
                    this.watchId = navigator.geolocation.watchPosition((position) => {
                        // this.showTrackingPosition(position);

                    }, (error) => {
                        if (error.code == error.PERMISSION_DENIED)
                            navigator.geolocation.clearWatch(this.watchId);
                        this.markers.splice(this.markers.indexOf(this.trackingMarker), 1);
                        this.isTrackingActive = false;
                        // this.zoom = 2.2;
                        this.zoom = this.maxMapZoom;
                        var denied = true;
                    });
                } else {
                    alert("Geolocation is not supported by this browser.");
                    // this.zoom = 2.2;
                    this.zoom = this.maxMapZoom;
                }
            } else {
                navigator.geolocation.clearWatch(this.watchId);
                this.markers.splice(this.markers.indexOf(this.trackingMarker), 1)
                this.isTrackingActive = false;
                if (this.agmMap.getZoom() == 16) {
                    this.zoom = 15.9;
                } else {
                    this.zoom = this.agmMap.getZoom();
                }
            }
            this.openOptions();
        }
    }


    openExistingPinOptions() {
        this.pinManagerService.getSavedPinById(this.marker.id)
            .pipe(
                catchError(error => {
                    console.error();
                    this.nav.toggleLoading(false);
                    return throwError(() => error);
                })
            ).subscribe((response) => {
                this.existingPin = response;
                this.nav.toggleLoading(false);

                if (this.polygons.length > 0 && response?.fieldId !== this.fieldObject?.id) {
                    let field = this.polygons.find(p => p.id === response.fieldId);

                    if (field) {
                        this.fieldObject.id = field.id;
                        this.fieldObject.name = field.fieldName;
                    }
                }

                if(this.marker?.type !== 'labelPin'){
                    if (response.pinTypeId == 1) {
                    const dialogRef = this.dialog.open(MarkerPinComponent, {
                        data: {
                            pinTypeId: response.pinTypeId,
                            lat: response.lat,
                            lng: response.lng,
                            date: response.lastModified,
                            farm: this.farmName,
                            field: this.fieldObject?.name,
                            fieldId: response.fieldId,
                            creatingUser: response.userName + '  ' + response.userSurname,
                            tenantId: this.tenantId,
                            pinId: response.id,
                            pinDescription: response.description
                        }
                    })
                    dialogRef.afterClosed().subscribe(result => {
                        if (result == null) {

                            // this.markers = [];
                            setTimeout(() => {
                                this.getNewSavedPins();
                            }, 500)
                        }
                    })

                    } else if (response.pinTypeId == 2) {
                        const dialogRef = this.dialog.open(VirtualConsultantPinComponent, {
                            data: {
                                pinTypeId: response.pinTypeId,
                                lat: response.lat,
                                lng: response.lng,
                                date: response.lastModified,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                fieldId: response.fieldId,
                                creatingUser: response.userName + '  ' + response.userSurname,
                                tenantId: this.tenantId,
                                pinId: response.id,
                                pinDescription: response.description
                            }
                        })
                        dialogRef.afterClosed().subscribe(response => {
                            if (response == null) {

                                // this.markers = [];
                                setTimeout(() => {
                                    this.getNewSavedPins();
                                }, 500)
                            }
                        })

                    } else if (response.pinTypeId == 3) {
                        const dialogRef = this.dialog.open(SoftTissuePinSamplesComponent, {
                            data: {
                                pinTypeId: response.pinTypeId,
                                lat: response.lat,
                                lng: response.lng,
                                date: response.lastModified,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                fieldId: response.fieldId,
                                creatingUser: response.userName + '  ' + response.userSurname,
                                tenantId: this.tenantId,
                                pinId: response.id,
                                pinDescription: response.description
                            }
                        });
                        dialogRef.afterClosed().subscribe(response => {
                          // this.markers = [];
                          setTimeout(() => {
                            if(this.pinsCalled) {
                                this.getNewSavedPins();
                            } else {
                                this.reloadMarker(response);
                            }
                          }, 500)
                        });

                    }
                    else if (response.pinTypeId == 4) {
                        const dialogRef = this.dialog.open(SoilPinSamplesComponent, {
                            data: {
                                pinTypeId: response.pinTypeId,
                                lat: response.lat,
                                lng: response.lng,
                                date: response.lastModified,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                fieldId: response.fieldId,
                                creatingUser: response.userName + '  ' + response.userSurname,
                                tenantId: this.tenantId,
                                pinId: response.id,
                                pinDescription: response.description
                            }
                        });
                        dialogRef.afterClosed().subscribe(response => {
                          // this.markers = [];
                          setTimeout(() => {
                            if(this.pinsCalled) {
                                this.getNewSavedPins();
                            } else {
                                this.reloadMarker(response);
                            }
                          }, 500)
                        });
                    }
                    else if (response.pinTypeId == 5) {
                        const dialogRef = this.dialog.open(WaterPinComponent, {
                            data: {
                                pinTypeId: response.pinTypeId,
                                lat: response.lat,
                                lng: response.lng,
                                date: response.lastModified,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                fieldId: response.fieldId,
                                creatingUser: response.userName + '  ' + response.userSurname,
                                tenantId: this.tenantId,
                                pinId: response.id,
                                pinDescription: response.description
                            }
                        });
                        dialogRef.afterClosed().subscribe(response => {
                            if (response == null) {

                                // this.markers = [];
                                setTimeout(() => {
                                    this.getNewSavedPins();
                                }, 500)
                            }
                        });
                    }
                    else if (response.pinTypeId == 6) {
                        const dialogRef = this.dialog.open(DiseasePinComponent, {
                            data: {
                                pinTypeId: response.pinTypeId,
                                lat: response.lat,
                                lng: response.lng,
                                date: response.lastModified,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                fieldId: response.fieldId,
                                creatingUser: response.userName + '  ' + response.userSurname,
                                tenantId: this.tenantId,
                                pinId: response.id,
                                pinDescription: response.description
                            }
                        });
                        dialogRef.afterClosed().subscribe(response => {
                            if (response == null) {

                                // this.markers = [];
                                setTimeout(() => {
                                    this.getNewSavedPins();
                                }, 500)
                            }
                        });
                    }
                    else if (response.pinTypeId == 7) {
                        const dialogRef = this.dialog.open(PestPinComponent, {
                            data: {
                                pinTypeId: response.pinTypeId,
                                lat: response.lat,
                                lng: response.lng,
                                date: response.lastModified,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                fieldId: response.fieldId,
                                creatingUser: response.userName + '  ' + response.userSurname,
                                tenantId: this.tenantId,
                                pinId: response.id,
                                pinDescription: response.description
                            }
                        });

                        dialogRef.afterClosed().subscribe(response => {
                            if (response == null) {

                                // this.markers = [];
                                setTimeout(() => {
                                    this.getNewSavedPins();
                                }, 500)
                            }
                        });
                    } else if (response.pinTypeId == 8) {
                        this.existingMarker = response;
                        this.openExistingYielsEstimationPinOptions()
                    }

                    else if (response.pinTypeId == 9) {
                        this.existingMarker = response;
                        this.openExistingNtesterPinOptions();
                    }

                    else if (response.pinTypeId == 10 || response.pinType?.id == 10) {
                        // Field Inspection pin — open as dialog consistent with other pin types
                        this.nav.toggleLoading(false);
                        if (!this.helper.canAccessFieldInspection()) { return; }
                        this.dialog.open(FieldInspectionDialogComponent, {
                            data: {
                                pinId: response.id,
                                fieldId: response.fieldId,
                                tenantId: this.tenantId,
                                farm: this.farmName,
                                field: this.fieldObject?.name,
                                lat: response.lat,
                                lng: response.lng,
                                viewOnly: false,
                                isNewInspection: false,
                                cropDefinitions: undefined
                            },
                            width: '900px',
                            maxWidth: '95vw',
                            height: '88vh',
                            maxHeight: '88vh',
                            autoFocus: false
                        });
                    }

                }

             })   

    }


    openExistingYielsEstimationPinOptions() {
        this.pinManagerService.getYieldestimationPinById(this.existingPin?.id)
            .pipe(
                catchError(error => {
                    console.error();
                    return throwError(() => error);
                })
            ).subscribe((response) => {
                this.existingPin = response?.pin;
                if (this.polygons.length > 0 && response?.pin?.fieldId !== this.fieldObject?.id) {
                    let field = this.polygons.find(p => p.id === response?.pin?.fieldId);

                    if (field) {
                        this.fieldObject.id = field.id;
                        this.fieldObject.name = field.fieldName;
                    }
                }

                // if pinType?.id == 8
                const dialogRef = this.dialog.open(YieldEstimationPinComponent, {
                    data: {
                        pinTypeId: this.selectedPinType?.id,
                        selectedPinType: this.selectedPinType?.name,
                        lat: response?.pin?.lat ?? this.existingMarker?.lat,
                        lng: response?.pin?.lng ?? this.existingMarker?.lng,
                        date: response?.pin?.lastModified ?? this.existingMarker?.lastModified,
                        farm: this.farmName,
                        field: this.fieldObject?.name,
                        fieldId: this.fieldObject?.id,
                        pinId: this.marker?.id,
                        pinDescription: response?.pin?.description ?? this.existingMarker?.description,
                        unitOfMeasureId: response?.unitOfMeasureId,
                        yieldEstimation: response?.yieldEstimation,
                        yieldWeightedValue: response?.yieldWeightedValue,
                        estimationDate: response?.estimationDate,
                        dateCreated: response?.dateCreated,
                        dateModified: response?.dateModified ?? this.existingMarker.lastModified,
                        creatingUser: this.existingMarker?.userName + '  ' + this.existingMarker?.userSurname,
                    }
                });

                dialogRef.afterClosed().subscribe(response => {
                    this.nav.toggleLoading(false);
                    if (response == null) {

                        // this.markers = [];
                        setTimeout(() => {
                            this.getNewSavedPins();
                        }, 500)
                    }
                });

            })

    }

    openExistingNtesterPinOptions() {
        this.pinManagerService.getSavedNTesterPinById(this.marker.id)
            .pipe(
                catchError(error => {
                    console.error();
                    return throwError(() => error);
                })
            ).subscribe((response) => {
                this.existingPin = response?.pin;
                if (this.polygons.length > 0 && response?.pin?.fieldId !== this.fieldObject?.id) {
                    let field = this.polygons.find(p => p.id === response?.pin?.fieldId);

                    if (field) {
                        this.fieldObject.id = field.id;
                        this.fieldObject.name = field.fieldName;
                    }
                }
                // if pin TypeId == 9
                const dialogRef = this.dialog.open(NTesterPinComponent, {
                    data: {
                        pinTypeId: this.selectedPinType?.id,
                        selectedPinType: this.selectedPinType?.name,
                        lat: response?.pin?.lat ?? this.existingMarker?.lat,
                        lng: response?.pin?.lng ?? this.existingMarker?.lng,
                        date: response?.pin?.lastModified ?? this.existingMarker?.lastModified,
                        farm: this.farmName,
                        field: this.fieldObject?.name,
                        fieldId: this.fieldObject?.id,
                        pinId: this.marker?.id,
                        pinDescription: response?.pin?.description,
                        variety: response?.variety,
                        crop: response?.crop,
                        cultivar: response?.cultivar,
                        growthStage: response?.growthStage,
                        totalNitrogen: response?.totalNitrogen,
                        medianValue: response?.medianValue,
                        averageValue: response?.averageValue,
                        yieldTarget: response?.yieldTarget,
                        alreadyApplied: response?.alreadyApplied,
                        proteinTarget: response?.proteinTarget,
                        nRecommendation: response?.nRecommendation,
                    }
                });

                dialogRef.afterClosed().subscribe(response => {
                    if (response == null) {

                        // this.markers = [];
                        setTimeout(() => {
                            this.getNewSavedPins();
                        }, 500)
                    }
                });
            })

    }


    getNewSavedPins() {
        if(this.pinsCalled) {
            this.pinManagerService.getSavedPinsByFarmId(this.farmId, this.tenantId, this.savedPinStartDate, this.savedPinEndDate)
                .pipe(
                    catchError(error => {
                        console.error();
                        return throwError(() => error);
                    })
                ).subscribe((response) => {

                this.markers = this.markers.filter(m => m.type === 'labelPin');
                this.newSavedPins = response;
                this.savedLabelPins = response;
                if (this.newSavedPins !== null) {
                    this.nav.toggleLoading(false);
                }
                this.newSavedPinsData = [];

                //CONFIRM SELECTED PIN TYPE

                this.newSavedPins.forEach((newPin) => {

                    if (this.selectedPinType?.id == undefined) {


                        this.savedPinsDataCounter = 0;
                        let id = newPin.id;
                        let lat = newPin.lat;
                        let lng = newPin.lng;
                        let description = newPin.description;

                        let tmpMarker = {
                            id: newPin.id,
                            position: { lat: lat, lng: lng },
                            title: description,
                            content: this.createMarkerContent(this.setPinTypeIcon(newPin)),
                            type: 'pin',
                            creatingUser: newPin.userName + " " + newPin.userSurname
                        };
                        this.markers.push(tmpMarker);
                        if(this.markers){
                            this.isPinMarkersVisible = true;
                        }
                    }

                    if (newPin.pinTypeId === this.selectedPinType?.id) {
                        this.savedPinsDataCounter = 0;
                        let id = newPin.id;
                        let lat = newPin.lat;
                        let lng = newPin.lng;
                        let description = newPin.description;

                        let tmpMarker = {
                            id: newPin.id,
                            position: { lat: lat, lng: lng },
                            title: description,
                            content: this.createMarkerContent(this.setPinTypeIcon(newPin)),
                            type: 'pin',
                            creatingUser: newPin.userName + " " + newPin.userSurname
                        };
                        this.markers.push(tmpMarker);
                        if(this.markers){
                            this.isPinMarkersVisible = true;
                        }
                    }
                })

                if(this.isPinLabelsShowing) {
                    this.setPinLabels();
                }
            })
        }
    }

    openSnackBar(message: string, action: string) {

        this._snackBar.open(message, action, {
            duration: 5000,
        });
    }

    loadSavedPins() {

        this.openSnackBar(this.translate.instant('FIELD.LOADING-SAVED-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
        this.openOptions();
    }






    newShowSavedPins() {
        const dialogRef = this.dialog.open(ViewSavedPinComponent);

        dialogRef.afterClosed().subscribe(result => {

            if (result.option == 'clear') {
                 for (let i = 0; i < this.markers.length; i++) {
                    if (this.markers[i].type == 'pin' || this.markers[i].type !== 'labelPin') {
                        this.markers.splice(i, 1);
                        i--;
                    }
                }

                this.newSavedPins = [];
                this.isPinMarkersVisible = false;
                this.pinsCalled = false;

            } else if (result.applyObj.option === 'apply') {
                this.pinsCalled = true;

                if (result.applyObj.selectecPinType == null) {
                    this.selectedPinType.id = 0;
                    this.savedPinStartDate = result.applyObj.filterStartDate;
                    this.savedPinEndDate = result.applyObj.filterEndDate;

                } else {
                    this.selectedPinType = result.applyObj.selectecPinType;
                    this.savedPinStartDate = result.applyObj.filterStartDate;
                    this.savedPinEndDate = result.applyObj.filterEndDate;
                }

                this.getNewSavedPins();

                this.spinner.show();
                let isOnMap = false;

                for (let i = 0; i < this.tmpMarkers.length; i++) {
                  if (!this.pinMarkers.includes(this.tmpMarkers[i])) {
                    isOnMap = true;
                    this.pinMarkers.push(this.tmpMarkers[i]);
                  }
                }

                if (isOnMap) {
                  if (this.tmpData.length > 0) {
                    let counter = 0;
                    for (let i = 0; i < this.tmpData.length; i++) {
                      this.barChartData.push(this.tmpData[i]);
                      counter++;
                      if (counter == this.tmpData.length) {
                        setTimeout(() => {
                          // this.getCharts();
                          this.spinner.hide();
                        }, 100);
                      }
                    }
                  }
                }
            }
        })
    }

    setPinTypeIcon(pinType) {
        if (pinType.pinTypeId == 1) {
            return this.iconUrl.urlMarker;
        }
        else if (pinType.pinTypeId == 2) {
            return this.iconUrl.urlSoftVirualConsultant;
        }
        else if (pinType.pinTypeId == 3) {
            if(pinType?.is_completed) {
                return this.iconUrl.urlSoftTissueCompleted;
            } else {
                return this.iconUrl.urlSoftTissue;
            }
        }
        else if (pinType.pinTypeId == 4) {
            if(pinType?.is_completed) {
                return this.iconUrl.urlSoilCompleted;
            } else {
                return this.iconUrl.urlSoil;
            }
        }
        else if (pinType.pinTypeId == 5) {
            return this.iconUrl.urlWater;
        }
        else if (pinType.pinTypeId == 6) {
            return this.iconUrl.urlDisease;
        }
        else if (pinType.pinTypeId == 7) {
            return this.iconUrl.urlPest;
        }
        else if (pinType.pinTypeId == 8) {
            return this.iconUrl.urlYieldEst;
        }
        else if (pinType.pinTypeId == 9) {
            return this.iconUrl.urlNester;
        }
        else if (pinType.pinTypeId == 10) {
            return this.iconUrl.urlFieldInspection;
        }
    }

    // openClearDialog() {

    //     const dialogRef = this.dialog.open(PinClearComponent, {
    //         data: {
    //             isFarmLevel: true
    //         }
    //     });

    //     dialogRef.afterClosed().subscribe(result => {
    //         let option = result.option;
    //         // let pinMarker = this.markers;
    //         this.newSavedPins = [];
    //         if (option == 'clear') {
    //             // this.showGraphs = false;
    //             // this.scrolled = false;

    //             // for (let i = 0; i < this.markers.length; i++) {
    //             //     if (this.markers[i].type == 'pin') {
    //             //         // this.markers.splice(i, 1);
    //             //         // i--;
                   
    //             //     }
    //             // }
    //             this.markers = [];
    //             this.tmpMarkers = [];
    //             this.pinMarkers = [];
    //             this.newSavedPins = [];
    //             this.pinCounter = 1;
    //             this.barChartData = [];
    //             // this.markers = pinMarker;
    //             // this.getPinDataForField();
    //         }
    //     });
    // }

    // clearPins() {

    //     if (this.markers.length != 0) {
    //         this.openClearDialog();
    //     } else {
    //         this.openSnackBar(this.translate.instant('FIELD.ERR-NO-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
    //     }
    //     this.openOptions();
    // }

    toggleNotifications() {
        if (this.notifications) {
            this.notifications = false;
        } else {
            this.notifications = true;
        }
        let farmNotifications = {
            farmId: this.farmId,
            receiveNotifications: this.notifications
        }
        this.farmManagementService.updateFarmNotificationStatus(farmNotifications).subscribe((value => {
            this.openSnackBar(this.translate.instant("MAPPING.FARM-NOTIFICATIONS-UPDATED"), this.translate.instant('SNACKBAR.DISMISS'));
        }));
        this.openOptions();
    }

    showTrackingPosition(position) {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.center = { lat: this.latitude, lng: this.longitude };

        let location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

        // @ts-ignore
        this.agmMap.panTo(location);

        if (!this.trackingMarker) {
            var marker = {
                id: "tracking",
                position: { lat: position.coords.latitude, lng: position.coords.longitude }
            };

            this.trackingMarker = marker;
            this.markers.push(this.trackingMarker);
        } else {
            this.markers.splice(this.markers.indexOf(this.trackingMarker), 1)
            this.trackingMarker.lat = position.coords.latitude;
            this.trackingMarker.lng = position.coords.longitude;
            this.markers.push(this.trackingMarker)
        }
    }

    toggleLabels() {
        if (this.showOverlay) {
            if (this.isLabelsShowing) {
                this.isLabelsShowing = false;
                this.markers.forEach(marker => {
                    this.currentMarkers.push(marker);
                });

                for (let i = 0; i < this.markers.length; i++) {
                    if (this.markers[i].type !== 'pin' && this.markers[i].type !== 'pinLabel') {
                        this.markers.splice(i, 1);
                        i--;
                    }
                }


                // this.markers = [];
            } else {
                this.currentMarkers.forEach(marker => {
                    this.markers.push(marker);
                });
                this.currentMarkers = [];
                this.isLabelsShowing = true;
            }
        } else {
            this.openSnackBar(this.translate.instant("MAPPING.CHOOSE-FARM"), this.translate.instant("SNACKBAR.DISMISS"));
        }
        this.openOptions();
    }

    togglePinLabels() {

        this.isPinLabelsShowing = !this.isPinLabelsShowing;
                 
        this.setPinLabels();
        this.openOptions();
    }

    setPinLabels() {
        this.newSavedPins.forEach(newPin => {
            if ((this.selectedPinType?.id == undefined || newPin?.pinTypeId === this.selectedPinType?.id) && this.isPinLabelsShowing) {

                let defaultPinDescription = "Unknown Pin";
                this.savedPinsDataCounter = 0;
                let position = null;
                let lat = null, lng = null;

                if(newPin?.position) {
                    position = newPin.position;
                } else {
                    lat = newPin.lat;
                    lng = newPin.lng;
                }

                let description = newPin?.title ?? newPin.description;

                let tmpMarker = {
                    id: newPin.id,
                    position: position ?? { lat: lat, lng: lng },
                    title: description ? description : defaultPinDescription,
                    content: this.createMarkerWithLabel(description ? description : defaultPinDescription),
                    type: 'pinLabel',
                    creatingUser: newPin.userName + " " + newPin.userSurname
                };

                this.markers.push(tmpMarker);

            }
            else if(!this.isPinLabelsShowing){

                for (let i = 0; i < this.markers.length; i++) {
                    if (this.markers[i].type == 'pinLabel' && this.markers[i].type !== 'pin') {
                        this.markers.splice(i, 1);
                        i--;
                    }
                }
            }
        });
    }

    findNdviAnalysis(histories, result) {
        histories.forEach(history => {
            var fieldFound = false;
            if (history.type.toLowerCase().includes("nvdi")) {
                this.ndviHistories.forEach(element => {
                    if (history.fieldId == element.fieldId) {
                        fieldFound = true;
                    }
                });
                if (!fieldFound) {
                    let overlay = false;
                    if (result.overlay.date == history.lastModified) {
                        overlay = true;
                    } else {
                        for (let i = 1; i < result.overlay.variance + 1; i++) {
                            if (moment(result.overlay.date).add(i, "days").isSame(moment(history.lastModified)) && !overlay) {
                                overlay = true;
                                break;
                            } else if (moment(result.overlay.date).subtract(i, "days").isSame(moment(history.lastModified)) && !overlay) {
                                overlay = true;
                                break;
                            }
                        }
                    }
                    if (overlay) {
                        this.ndviHistories.push(history);
                    }
                }
            }
        });

        if (this.ndviHistories.length < 1) {
            this.nav.toggleLoading(false);
            // this.openSnackBar(this.translate.instant('MAPPING.NO-NDVI'), this.translate.instant("SNACKBAR.DISMISS"));
        } else {
            // this.nav.toggleLoading(true);
            this.ndviHistories.forEach(history => {

                this.overlayAllAnalysis(history, "nvdi", history.fieldId, history.lastModified);
            });
            if (this.ndviHistories.length < this.fieldCounter) {
                this.nav.toggleLoading(false);
                this._snackBar.open(this.translate.instant('MAPPING.ERR-OVERLAY-ALL-NDVI'), this.translate.instant("SNACKBAR.DISMISS"));
            }
        }
        // this.nav.toggleLoading(false);
    }

    findSpesificAnalysis(histories, result) {
        histories.forEach(history => {
            var fieldFound = false;
            if (result.overlayAnalysis.analysis == "ndvi") {
                if (history.type.toLowerCase().includes("nvdi")) {
                    this.ndviHistories.forEach(element => {
                        if (history.fieldId == element.fieldId) {
                            fieldFound = true;
                        }
                    });
                    if (!fieldFound) {
                        let overlay = false;
                        if (result.overlayAnalysis.date == history.lastModified) {
                            overlay = true;
                        } else {
                            for (let i = 1; i < 7 + 1; i++) {
                                if (moment(result.overlayAnalysis.date).add(i, "days").isSame(moment(history.lastModified)) && !overlay) {
                                    overlay = true;
                                    break;
                                } else if (moment(result.overlayAnalysis.date).subtract(i, "days").isSame(moment(history.lastModified)) && !overlay) {
                                    overlay = true;
                                    break;
                                }
                            }
                        }
                        if (overlay) {
                            this.ndviHistories.push(history);
                        }
                    }
                }
            } else if (result.overlayAnalysis.analysis == "ni") {
                if (history.type.toLowerCase().includes("ni")) {
                    this.niHistories.forEach(element => {
                        if (history.fieldId == element.fieldId) {
                            fieldFound = true;
                        }
                    });
                    if (!fieldFound) {
                        let overlay = false;
                        if (result.overlayAnalysis.date == history.lastModified) {
                            overlay = true;
                        } else {
                            for (let i = 1; i < 7 + 1; i++) {
                                if (moment(result.overlayAnalysis.date).add(i, "days").isSame(moment(history.lastModified)) && !overlay) {
                                    overlay = true;
                                    break;
                                } else if (moment(result.overlayAnalysis.date).subtract(i, "days").isSame(moment(history.lastModified)) && !overlay) {
                                    overlay = true;
                                    break;
                                }
                            }
                        }
                        if (overlay) {
                            this.niHistories.push(history);
                        }
                    }
                }
            }
        });

        if (result.overlayAnalysis.analysis == "ndvi") {
            if (this.ndviHistories.length < 1) {
                this.nav.toggleLoading(false);
                // this.openSnackBar(this.translate.instant('MAPPING.NO-NDVI'), this.translate.instant("SNACKBAR.DISMISS"));
            } else {
                // this.nav.toggleLoading(false);
                this.ndviHistories.forEach(history => {
                    this.overlayAllAnalysis(history, "nvdi", history.fieldId, history.lastModified);
                });
            }
        } else {
            if (this.niHistories.length < 1) {
                this.nav.toggleLoading(false);
                this.openSnackBar(this.translate.instant('MAPPING.NO-NI'), this.translate.instant("SNACKBAR.DISMISS"));
            } else {
                this.niHistories.forEach(history => {
                    this.overlayAllAnalysis(history, "ni", history.fieldId, history.lastModified);
                });
            }
        }
    }

    overlayAllAnalysis(history: History, type: string, fieldId: number, lastModified: string) {
        this.nav.toggleLoading(true);
        this.analysisManagementService.getAnalysisTypes(history.id).subscribe(analysisTypes => {
            this.geoJsonObject = [];
            analysisTypes.forEach(analysisType => {
                this.analysisManagementService.getAnalysisImage(history.id, analysisType.id).subscribe(urlObject => {
                    if (urlObject != null) {
                        this.analysisManagementService.getAnalysisColoursArea(history.id, analysisType.id).subscribe(analysisColours => {
                            let colours = [];
                            let areas = [];
                            analysisColours.forEach(colour => {
                                if (!colours.includes(colour.colour)) {
                                    colours.push(colour.colour);
                                    areas.push(colour.area);
                                }
                            })
                            this.fieldLegends = [];
                            this.fieldLegends1 = [];

                            let analysisTypeLegendProperties = analysisType.analysisTypeLegend.analysisTypeLegendProperties;
                            analysisTypeLegendProperties.forEach(analysisTypeLegendProperty => {
                                if (colours.includes(analysisTypeLegendProperty.Colour)) {
                                    let index = colours.indexOf(analysisTypeLegendProperty.Colour);
                                    let fieldLegend: FieldLegend = { value: "", color: "", area: "" };
                                    if (analysisTypeLegendProperty.textValue == null || analysisTypeLegendProperty.textValue == "null") {
                                        if (analysisTypeLegendProperty.maxValue != 1000000) {
                                            fieldLegend.value = analysisTypeLegendProperty.minValue + " - " + analysisTypeLegendProperty.maxValue;
                                        } else {
                                            fieldLegend.value = "> " + analysisTypeLegendProperty.minValue;
                                        }
                                    } else {
                                        fieldLegend.value = analysisTypeLegendProperty.textValue;
                                    }
                                    fieldLegend.color = analysisTypeLegendProperty.Colour;
                                    fieldLegend.area = areas[index].toFixed(2);

                                    this.fieldLegends.push(fieldLegend);
                                    this.fieldLegends1.push(fieldLegend);

                                    this.fieldLegends.sort(function (a, b) {
                                        return Number.parseFloat(a.value.replace(/^\W+/, 'z')) - Number.parseFloat(b.value.replace(/^\W+/, 'z'));
                                    });
                                    this.fieldLegends1.sort(function (a, b) {
                                        return Number.parseFloat(a.value.replace(/^\W+/, 'z')) - Number.parseFloat(b.value.replace(/^\W+/, 'z'));
                                    });
                                }
                            })
                            let image = {
                                id: history.id,
                                type: type,
                                fieldId: fieldId,
                                lastModified: lastModified,
                                fieldLegends: this.fieldLegends,
                                fieldLegends1: this.fieldLegends1
                            }
                            this.overlayedAnalysis.push(image);
                        });
                        this.analysisManagementService.getBoundingBox(history.id, analysisType.id).subscribe(boundingBox => {

                            let bounds = new google.maps.LatLngBounds();
                            bounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                            bounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));

                            //@ts-ignore
                            let url = urlObject.url;
                            // console.log(url)
                            // this.analysisManagementService.getImageAsBlob(url).subscribe(response => {
                            //     console.log(response)
                            //     let typedArray = new Uint8Array(response);
                            //     let base64String = this.arrayBufferToBase64(typedArray);
                            //     let image = 'data:image/jpg;base64, ' + base64String;
                            //     // HOTFIX REMOVE IF THIS WORKS REVERT IF ELSE

                            // });

                            let object = { image: url, bounds: bounds, fieldId: fieldId };

                            let count = -1;
                            for (let i = 0; i < this.images.length; i++) {
                                if (this.images[i].fieldId == fieldId) {
                                    count = i;
                                }
                            }

                            if (count != -1) {
                                this.images.splice(count, 1);
                            }
                            this.images.push(object);
                        });
                    }
                });
            });
            this.nav.toggleLoading(false);
        });
    }

    captureRainfall() {
        this.openRainMeterSelection();
    }

    showWeatherForecast() {
        this.toggleWeatherForecast();
    }

    toggleWeatherForecast() {
        this.showWeatherCard = !this.showWeatherCard;
        
        if (this.showWeatherCard && this.weatherForecasts.length === 0) {
            let lat = this.center.lat;
            let lng = this.center.lng;
            
            if (this.farmBounds) {
                const center = this.farmBounds.getCenter();
                lat = center.lat();
                lng = center.lng();
            }
            
            this.isWeatherLoading = true;
            this.weatherForecastService.getWeatherForecast(lat, lng).subscribe({
                next: (forecasts) => {
                    this.weatherForecasts = forecasts;
                    this.isWeatherLoading = false;
                },
                error: () => {
                    this.showWeatherCard = false;
                    this.isWeatherLoading = false;
                    this._snackBar.open('Failed to load weather forecast', 'Close', { duration: 3000 });
                }
            });
        }
    }

    openRainMeterSelection() {
        this.nav.toggleLoading(true);
        const dialogRef = this.dialog.open(RainMeterSelectionComponent, {
            data: {
                rainMeters: this.rainMeters
            },
            maxWidth: "100%",
            minWidth: "30%"
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                let id = result.id;
                let name = result.name;
                this.rainfallService.getRainfall(id).subscribe((rainfall) => {
                    this.rainfallService.getRainfallClassifications().subscribe((rainfallClassifications) => {
                        this.openRainfallCapture(rainfall, rainfallClassifications, name, id);
                    });
                });
            }
        });
        this.nav.toggleLoading(false);
        this.openOptions();

    }

    openRainfallCapture(rainfall, rainfallClassifications, name, rainMeterId) {
        this.nav.toggleLoading(true);
        const dialogRef = this.dialog.open(RainfallCaptureComponent, {
            data: {
                rainfall: rainfall,
                rainfallClassifications: rainfallClassifications,
                name: name,
                rainMeterId: rainMeterId
            },
            maxWidth: "100%",
            minWidth: "30%"
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                let rainfall = result.rainfall;
                this.nav.toggleLoading(false);
                this.rainfallService.insertRainfall(rainfall).subscribe((result) => {
                    this.nav.toggleLoading(false);
                    this.openSnackBar(this.translate.instant("MAPPING.RAINFALL-CAPTURED"), this.translate.instant("SNACKBAR.DISMISS"));
                });
            }
        });
        this.nav.toggleLoading(false);
    }

    toggleFarms(width) {

        if(this.selectedFarmIndex > -1) {
            this.filteredFarms[this.selectedFarmIndex].showOptions = false;
        }
        if (width > 50) {
            this.farmWidth = width;
            this.showFields = false;
        } else {
            this.showFields = true;
        }
        this.animationState = this.animationState === 'out' ? 'in' : 'out';
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        if (this.saveFields || this.isDrawingMode || this.editing || this.editingFields) {
            this.openSnackBar(this.translate.instant("MAPPING.FINISH-EDITING"), this.translate.instant("SNACKBAR.DISMISS"));
        } else {
            this.auth.logout();
        }
    }

    openInfo(marker, markerObject) {
        this.infoWindow.open(marker);
        this.marker = markerObject;
    }

    openPinInfo(marker, markerObject) {
        this.infoWindow.open(marker);
        this.pinMarker = markerObject;
    }

    onFarmSearch(value) {
        this.selectedFarm = value;
        this.filteredFarms = this.farms.filter(
            item => item.name.toLowerCase().includes(this.selectedFarm.toLowerCase())
        );
        this.filteredFarms.forEach(f => f.showOptions = false);
    }

    addFarm() {
        this.nav.toggleLoading(true);
        if (this.saveFields || this.isDrawingMode || this.editing) {
            this.openSnackBar(this.translate.instant("MAPPING.FINISH-EDITING"), this.translate.instant("SNACKBAR.DISMISS"));
        } if(this.openVardaBoundary && this.vardaField?.getPath()) {
            this.openSnackBar(this.translate.instant("MAPPING.VARDA-BOUNDARY"), this.translate.instant("SNACKBAR.DISMISS"));
        } else {
            this.openVardaBoundary = false;
            const dialogRef = this.dialog.open(AddFarmComponent, {
                data: {},
                maxWidth: "100%",
                minWidth: "23%"
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result != null) {
                    if (result.option == "add") {
                        this.nav.toggleLoading(false);
                        this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
                            this.agmMap.zoom = this.maxMapZoom;
                            this.agmMap.panTo(this.center);
                            if (farms != null) {
                                farms.sort((a, b) => a.name.localeCompare(b.name));
                                this.filteredFarms = farms;
                                this.farms = farms;
                                this.farmSubjects.next(farms);
                                let jsonFarms = JSON.stringify(farms);
                                sessionStorage.setItem("farms", jsonFarms);
                                this.nav.toggleLoading(false);
                                const newFarm = farms.find(f => f.id === result.farmId);
                                if (newFarm) {
                                    this.overlayBoundaryForSelectedFarm(
                                        newFarm.id,
                                        newFarm.name,
                                        newFarm.numberOfFields,
                                        newFarm.size,
                                        newFarm.field,
                                        true
                                    );
                                }
                            } else {
                                this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
                            }
                        });
                    }
                }
            });
        }
        this.openOptions();
        this.nav.toggleLoading(false);
    }

    deleteFarm(farmId) {
        if (this.showOptions) {
            setTimeout(() => {
                this.showOptions = false
            }, 2000);
        }
        this.nav.toggleLoading(true);
        let sentFarmId: FarmId = {
            farmId: farmId,
            tenantId: this.tenantId,
            loadingUser: this.userId
        }
        this.delete = true;
        const dialogRef = this.dialog.open(DeleteFarmComponent, {
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                if (result.option == "delete") {
                    this.nav.toggleLoading(false);
                    this.boundaryManagementService.deleteFarm(sentFarmId).subscribe(result => {
                        this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
                            // this.agmMap.zoom = 2.2;
                            this.agmMap.zoom = this.maxMapZoom;
                            this.agmMap.panTo(this.center);
                            if (farms != null) {
                                farms.sort((a, b) => a.name.localeCompare(b.name));
                                this.filteredFarms = farms;
                                this.farms = farms;
                                this.farmSubjects.next(farms);
                                let jsonFarms = JSON.stringify(farms);
                                sessionStorage.setItem("farms", jsonFarms);
                                this.nav.toggleLoading(false);
                            } else {
                                this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
                            }
                            if (farmId == this.farmId) {
                                this.zoom = 4;
                                this.newPolygons.forEach((poly) => {
                                    poly.setMap(null);
                                });
                                this.addedPolygons.forEach((poly) => {
                                    poly.setMap(null);
                                });
                                this.polygonInteriors.forEach((poly1) => {
                                    poly1.setMap(null);
                                });
                                this.polygons = [];
                                this.markers = [];
                                this.newPolygons = [];
                                this.addedPolygons = [];
                                this.polygonInteriors = [];
                            }
                        });
                    });
                }
            }
            this.delete = false;
        });
        this.nav.toggleLoading(false);
    }

    addField(map) {
        if (this.oneAction) {
            this.openSnackBar(this.translate.instant("MAPPING.FINISH-EDITING"), this.translate.instant("SNACKBAR.DISMISS"));
            return;
        }
        if (this.openVardaBoundary && this.vardaField?.getPath()) {
            this.openSnackBar(this.translate.instant("MAPPING.VARDA-BOUNDARY"), this.translate.instant("SNACKBAR.DISMISS"));
            return;
        }

        this.openVardaBoundary = false;
        const dialogRef = this.dialog.open(AddFieldComponent, {
            data: { farmId: this.farmId },
            maxWidth: "100%",
            minWidth: "23%"
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null && result.option === 'add') {
                this.newFieldName = result.fieldName;
                this.oneAction = true;
                this.isDrawingMode = true;
                this.drawingType = 'polygon';
                this.drawnPoints = [];
                this.action = this.drawing + ': ' + this.newFieldName;
                this.disableBackButton();
                this.nav.enableMenu = false;
                this.agmMap.googleMap.setOptions({ draggableCursor: 'crosshair' });
                this.openOptions();
            }
        });
    }

    switchDrawingType(type: 'polygon' | 'circle' | null) {
        if (this.drawingType === type) return;
        this.clearDrawnMarkers();
        if (this.previewPolyline) {
            this.previewPolyline.setMap(null);
            this.previewPolyline = null;
        }
        if (this.previewPolygon) {
            this.previewPolygon.setMap(null);
            this.previewPolygon = null;
        }
        this.clearCircleDrawing();
        this.drawnPoints = [];

        this.drawingType = type;

        if (type === null) {
            this.agmMap.googleMap.setOptions({ draggableCursor: 'grab' });
        } else {
            this.agmMap.googleMap.setOptions({ draggableCursor: 'crosshair' });
        }
    }

    // initDrawingManager(map: GoogleMap, fieldName) {
    //
    //     this.nav.toggleLoading(true);
    //     this.disableBackButton();
    //     this.nav.enableMenu = false;
    //     this.drawingManager = new google.maps.drawing.DrawingManager({
    //         drawingMode: google.maps.drawing.OverlayType.POLYGON,
    //         drawingControl: true,
    //         drawingControlOptions: {
    //             position: google.maps.ControlPosition.TOP_CENTER,
    //             drawingModes: [
    //                 google.maps.drawing.OverlayType.CIRCLE,
    //                 google.maps.drawing.OverlayType.POLYGON
    //             ],
    //         },
    //         circleOptions: {
    //             fillOpacity: 0.0,
    //             editable: true,
    //         },
    //         polygonOptions: {
    //             fillOpacity: 0.0,
    //             editable: true,
    //         },
    //     });
    //     this.drawingManager.setMap(map.googleMap);
    //     google.maps.polygonOptions = this.polygonOptions;
    //
    //     google.maps.event.addListener(this.drawingManager, 'circlecomplete', (circle) => {
    //         let area = circle.getRadius() * circle.getRadius() * Math.PI;
    //         if (area < 10000000) {
    //             if (area > 1) {
    //                 this.circle = circle;
    //                 var radius = circle.getRadius();
    //                 var center = circle.getCenter();
    //                 var lat = center.lat();
    //                 var lng = center.lng();
    //
    //                 const dialogRef = this.dialog.open(NewFieldComponent, {
    //                     data: {}
    //                 });
    //
    //                 dialogRef.afterClosed().subscribe(result => {
    //                     if (result != null) {
    //                         if (result.option == "add") {
    //                             this.noBoundary = false;
    //                             var userId = this.helper.getUserId();
    //                             let addField: AddField = {
    //                                 name: fieldName,
    //                                 farmId: this.farmId,
    //                                 userId: userId
    //                             }
    //                             this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
    //                                 this.fieldId = result.id;
    //                                 let polygon: CirclePolygon = {
    //                                     lat: lat,
    //                                     lng: lng,
    //                                     radius: Math.round(radius),
    //                                     fieldId: this.fieldId,
    //                                     tenantId: this.tenantId,
    //                                     farmId: this.farmId,
    //                                     loadingUser: this.userId
    //                                 }
    //                                 this.boundaryManagementService.updateCircularField(polygon).subscribe((result) => {
    //                                     this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
    //                                     this.optionsReached = false;
    //                                     this.stillDrawing = false;
    //                                     this.splitField = false;
    //                                     this.oneAction = false;
    //                                     this.enableBackButton();
    //                                     this.nav.enableMenu = true;
    //                                     this.drawingManager.setMap(null);
    //                                     this.nav.toggleLoading(false);
    //                                     circle.setMap(null);
    //                                     this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
    //                                         this.agmMap.zoom = this.maxMapZoom;
    //                                         this.agmMap.panTo(this.center);
    //                                         if (farms != null) {
    //                                             farms.sort((a, b) => a.name.localeCompare(b.name));
    //                                             this.filteredFarms = farms;
    //                                             this.farms = farms;
    //                                             this.farmSubjects.next(farms);
    //                                             let jsonFarms = JSON.stringify(farms);
    //                                             sessionStorage.setItem("farms", jsonFarms);
    //                                           // this.overlayBoundary(this.farmId, this.farmName, this.fieldId);
    //                                           this.focusBoundingBox(this.fieldId);
    //                                         } else {
    //                                             this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
    //                                         }
    //                                     });
    //                                     this.checkCircle = true;
    //
    //                                     // setTimeout(() => {
    //                                     // this.overlayBoundary(this.farmId, this.farmName, this.fieldId);
    //                                     // }, 1000);
    //                                 });
    //                                 this.nav.toggleLoading(false);
    //                             });
    //
    //                             // if (inside && outside) {
    //                             // } else if (inside) { }
    //                             //   this.getPolygonArray(insidePoly, event.overlay);
    //                             //   const newBigPoly = new google.maps.Polygon({ paths: insidePoly.points });
    //                             //   var bigPoly = google.maps.geometry.encoding.encodePath(newBigPoly.getPath());
    //                             //   let multiPoly: MultiPolygonField;
    //                             //   if (this.polygonIsArray) {
    //                             //     multiPoly = {
    //                             //       polygonSmall: poly,
    //                             //       polygonBig: this.polygonArray,
    //                             //       fieldId: insidePoly.id
    //                             //     }
    //                             //   } else {
    //                             //     multiPoly = {
    //                             //       polygonSmall: poly,
    //                             //       polygonBig: bigPoly,
    //                             //       fieldId: insidePoly.id
    //                             //     }
    //                             //   }
    //                             //   this.base.updateMultiPolygonField(multiPoly).subscribe((result) => { });
    //                             //   this.updatePolygonField(polygon, drawingManager, event);
    //                             // } else if (outside) {
    //                             //   this.getPolygonArray(outsidePoly, event.overlay);
    //                             //   const newSmallPoly = new google.maps.Polygon({ paths: outsidePoly.points });
    //                             //   var smallPoly = google.maps.geometry.encoding.encodePath(newSmallPoly.getPath());
    //                             //   let multiPoly: MultiPolygonField;
    //                             //   if (this.polygonIsArray) {
    //                             //     multiPoly = {
    //                             //       polygonSmall: this.polygonArray,
    //                             //       polygonBig: poly,
    //                             //       fieldId: polygon.fieldId
    //                             //     }
    //                             //   } else {
    //                             //     multiPoly = {
    //                             //       polygonSmall: smallPoly,
    //                             //       polygonBig: poly,
    //                             //       fieldId: polygon.fieldId
    //                             //     }
    //                             //   }
    //                             //   this.base.updateMultiPolygonField(multiPoly).subscribe((result) => { });
    //                             //   this.updatePolygonField(polygon, drawingManager, event);
    //                             // } else {
    //                             //   this.updatePolygonField(polygon, drawingManager, event);
    //                             // }
    //                         } else if (result.option == "edit") {
    //                             // this.base.updateCircularField(polygon).subscribe((result) => {
    //                             //   this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
    //                             //   drawingManager.setMap(null);
    //                             //   this.nav.toggleLoading();
    //                             //   this.base.getTenantFarms(this.tenantId).subscribe((farms) => {
    //                             //     if (farms != null) {
    //                             //       farms.sort((a, b) => a.name.localeCompare(b.name));
    //                             //       this.filteredFarms = farms;
    //                             //       this.farms = farms;
    //                             //       this.farmSubjects.next(farms);
    //                             //       let jsonFarms = JSON.stringify(farms);
    //                             //       sessionStorage.setItem("farms", jsonFarms);
    //                             //       this.nav.toggleLoading();
    //                             //     } else {
    //                             //       this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
    //                             //     }
    //                             //     this.stillDrawing = false;
    //                             //     this.splitField = false;
    //                             //     circle.setMap(null);
    //                             //     this.overlayBoundary(this.farmId, this.farmName, 0);
    //                             //   });
    //                             // });
    //                             // setTimeout(() => {
    //                             //   this.editField(fieldId, map);
    //                             //         this.disableBackButton();
    //                             // this.nav.enableMenu = false;
    //                             //   this.editing = true;
    //                             //   this.oneAction = true;
    //                             //   this.action = this.busyEditing + ": " + fieldName;
    //                             // }, 7000);
    //                             this.stillDrawing = false;
    //                             this.splitField = false;
    //                             this.editNewField(map, circle, null, true, "field");
    //                             this.drawingManager.setMap(null);
    //                             this.editing = true;
    //                             this.oneAction = true;
    //                             this.action = this.busyEditing + ": " + fieldName;
    //                         } else if (result.option == "redraw" || result.option == "cancel") {
    //                             circle.setMap(null);
    //                             this.splitField = false;
    //                         }
    //                     }
    //                 });
    //             } else {
    //                 this.openSnackBar(this.translate.instant("MAPPING.SMALL-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
    //                 circle.setMap(null);
    //             }
    //         } else {
    //             this.openSnackBar(this.translate.instant("MAPPING.BIG-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
    //             circle.setMap(null);
    //         }
    //     });
    //
    //     google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
    //         if (event.type == 'polygon') {
    //             let area = google.maps.geometry.spherical.computeArea(event.overlay.getPath());
    //             if (area < 100000000) {
    //                 if (area > 1) {
    //                     this.polygon = event;
    //
    //                     // let interior = [];
    //                     // for (let i = 1; i < event.overlay.getPaths().getLength(); i++) {
    //                     //   interior.push(google.maps.geometry.encoding.encodePath(event.overlay.getPaths().getAt(i)));
    //                     // }
    //                     var poly = google.maps.geometry.encoding.encodePath(event.overlay.getPath());
    //
    //
    //                     const dialogRef = this.dialog.open(NewFieldComponent, {
    //                         data: {}
    //                     });
    //
    //                     dialogRef.afterClosed().subscribe(result => {
    //                         if (result != null) {
    //                             if (result.option == "add") {
    //                                 this.isOpen = false;
    //                                 this.noBoundary = false;
    //                                 this.oneAction = false;
    //                                 var userId = this.helper.getUserId();
    //                                 let addField: AddField = {
    //                                     name: fieldName,
    //                                     farmId: this.farmId,
    //                                     userId: userId
    //                                 }
    //                                 this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
    //                                     this.fieldId = result.id;
    //                                     this.nav.toggleLoading(false);
    //                                     let inside: boolean = false;
    //                                     let outside: boolean = false;
    //                                     let insidePoly = [];
    //                                     let outsidePoly = [];
    //                                     let indentInside = [];
    //                                     let indentOutside = [];
    //                                     let polyArray = event.overlay.getPath();
    //                                     const newPoly = new google.maps.Polygon({ paths: polyArray });
    //                                     for (let i = 0; i < this.polygons.length; i++) {
    //                                         const exixtingPoly = new google.maps.Polygon({ paths: this.polygons[i].points });
    //                                         var newPolyArray = event.overlay.getPath().getArray();
    //                                         for (let j = 0; j < newPolyArray.length; j++) {
    //                                             if (google.maps.geometry.poly.containsLocation(newPolyArray[j], exixtingPoly)) {
    //                                                 indentInside.push(true);
    //                                                 inside = true;
    //                                                 if (insidePoly.find(x => x.id == this.polygons[i].id)) {
    //                                                 } else {
    //                                                     insidePoly.push(this.polygons[i]);
    //                                                 }
    //                                             }
    //                                         }
    //                                         for (let j = 0; j < this.polygons[i].points.length; j++) {
    //                                             var lat = this.polygons[i].points[j].lat;
    //                                             var lng = this.polygons[i].points[j].lng;
    //                                             const latLng = new google.maps.LatLng(lat, lng);
    //                                             if (google.maps.geometry.poly.containsLocation(latLng, newPoly)) {
    //                                                 indentOutside.push(true);
    //                                                 outside = true;
    //                                                 if (outsidePoly.find(x => x == this.polygons[i].id)) {
    //                                                 } else {
    //                                                     outsidePoly.push(this.polygons[i].id);
    //                                                 }
    //                                             }
    //                                         }
    //                                     }
    //                                     let polygon: Polygon = {
    //                                       polygon: poly,
    //                                       interiorPolygons: null,
    //                                       fieldId: this.fieldId,
    //                                       edit: false,
    //                                       singleField: true,
    //                                       tenantId: this.tenantId,
    //                                       farmId: this.farmId,
    //                                       loadingUser: this.userId
    //                                     }
    //
    //                                     if (inside && outside) {
    //                                         this.updatePolygonFieldByPosition(polygon, this.drawingManager, event, insidePoly, outsidePoly, "both");
    //                                     } else if (inside) {
    //
    //                                         this.updatePolygonFieldByPosition(polygon, this.drawingManager, event, insidePoly, null, "inside");
    //
    //                                     } else if (outside) {
    //                                         this.updatePolygonFieldByPosition(polygon, this.drawingManager, event, outsidePoly, null, "outside");
    //                                     } else {
    //
    //
    //                                         this.updatePolygonField(polygon, this.drawingManager, event);
    //                                     }
    //                                     this.nav.toggleLoading(false);
    //                                 });
    //                             } else if (result.option == "edit") {
    //                                 this.stillDrawing = false;
    //                                 this.splitField = false;
    //                                 this.editNewField(map, null, event.overlay.getPath(), false, "field");
    //                                 this.drawingManager.setMap(null);
    //                                 this.oneAction = true;
    //                                 this.action = this.busyEditing + ": " + fieldName;
    //                             } else if (result.option == "redraw" || result.option == "cancel") {
    //                                 event.overlay.setMap(null);
    //                                 this.splitField = false;
    //                             }
    //                         }
    //                     });
    //                 } else {
    //                     this.openSnackBar(this.translate.instant("MAPPING.SMALL-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
    //                     event.overlay.setMap(null);
    //                 }
    //             } else {
    //                 this.openSnackBar(this.translate.instant("MAPPING.BIG-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
    //                 event.overlay.setMap(null);
    //             }
    //         }
    //     });
    //     this.nav.toggleLoading(false);
    // }

    getPolygonArray(polygon) {
        const newPolygonArray = new google.maps.Polygon({ path: polygon.points });

        var encodedArray = google.maps.geometry.encoding.encodePath(newPolygonArray.getPath());
    }

    updatePolygonField(polygon, drawingManager, event) {

        this.nav.toggleLoading(true);
        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe((result) => {

            if (result.result == 1) {
                this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
            } else if (result.result == 0) {
                this.openSnackBar(this.translate.instant("MAPPING.ADD-FIELD-ERROR"), this.translate.instant("SNACKBAR.DISMISS"));
                this.nav.toggleLoading(false);
            }
            if (drawingManager != null) {
                drawingManager.setMap(null);
                event.overlay.setMap(null);
            } else if(this.vardaField?.getPath()) {
              this.vardaField.setMap(null);
              this.vardaField = null;
            } else if (this.editablePolygon != null) {
                this.editablePolygon.setMap(null);
                if (this.polygon != null) {
                    this.polygon.overlay.setMap(null);
                }
            }


            this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
                if (farms != null) {
                    farms.sort((a, b) => a.name.localeCompare(b.name));
                    this.filteredFarms = farms;
                    this.farms = farms;
                    this.farmSubjects.next(farms);
                    let jsonFarms = JSON.stringify(farms);
                    sessionStorage.setItem("farms", jsonFarms);
                    // this.nav.toggleLoading();
                } else {
                    this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
                }
                this.farmManagementService.getFarmBoundingBox(this.farmId).subscribe({
                    next: (boundingBox) => {
                        this.farmBounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1),
                            new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2)
                        );
                        this.overlayBoundary(this.farmId, this.farmName, 0);
                        this.optionsReached = false;
                        this.isDrawingMode = false;
                        this.splitField = false;
                        this.oneAction = false;
                        this.nav.toggleLoading(false);
                    },
                    error: () => {
                        this.overlayBoundary(this.farmId, this.farmName, 0);
                        this.optionsReached = false;
                        this.isDrawingMode = false;
                        this.splitField = false;
                        this.oneAction = false;
                        this.nav.toggleLoading(false);
                    }
                });
            });
            this.enableBackButton();
            this.nav.enableMenu = true;
        }, error =>{
          console.log(error)
        });
        this.nav.toggleLoading(false);
    }

    updatePolygonFieldByPosition(polygon, drawingManager, event, poly, poly1, position) {
        this.nav.toggleLoading(true);
        polygon.singleField = false;

        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe((result) => {
            this.enableBackButton();
            this.nav.enableMenu = true;
            if (result.result == 1) {
                this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
                if (drawingManager != null) {
                    drawingManager.setMap(null);
                    event.overlay.setMap(null);
                } else if (this.editablePolygon != null) {
                    this.editablePolygon.setMap(null);
                    if (this.polygon != null) {
                        this.polygon.overlay.setMap(null);
                    }
                }

                if (position == "inside") {
                    const newBigPoly = new google.maps.Polygon({ paths: poly[0].points });
                    let existingHoles = [];
                    for (let i = 0; i < this.polygons.length; i++) {
                        for (let j = 0; j < this.polygons[i].points.length; j++) {
                            var lat = this.polygons[i].points[j].lat;
                            var lng = this.polygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newBigPoly)) {

                                if (existingHoles.find(x => x == this.polygons[i].id)) {
                                } else {
                                    if (this.polygons[i].id != poly[0].id) {
                                        existingHoles.push(this.polygons[i].id);
                                    }
                                }
                            }
                        }
                    }

                    let counter = 0;
                    for (let i = 0; i < poly.length; i++) {
                        let multiPoly: MultiPolygonField;
                        multiPoly = {
                            fieldId: poly[i].id,
                            smallField: polygon.fieldId,
                            multipleFields: false,
                            edit: polygon.edit,
                            polygon: polygon.polygon,
                            originalPolygon: null,
                            tenantId: this.tenantId,
                            farmId: this.farmId,
                            loadingUser: this.userId
                        }
                        this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            counter++;
                            if (counter == poly.length) {
                                // this.overlayBoundary(this.farmId, this.farmName, 0);
                                this.focusBoundingBox();
                                this.optionsReached = false;
                                this.isDrawingMode = false
                                this.splitField = false;
                                this.oneAction = false;
                                this.nav.toggleLoading(false);
                            }
                        });
                    }
                } else if (position == "outside") {


                    let multiPoly: MultiPolygonField;
                    multiPoly = {
                        fieldId: polygon.fieldId,
                        smallField: poly,
                        multipleFields: true,
                        edit: polygon.edit,
                        polygon: polygon.polygon,
                        originalPolygon: null,
                        tenantId: this.tenantId,
                        farmId: this.farmId,
                        loadingUser: this.userId
                    }
                    this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                        // this.overlayBoundary(this.farmId, this.farmName, 0);
                        this.focusBoundingBox();
                        this.optionsReached = false;
                        this.isDrawingMode = false;
                        this.splitField = false;
                        this.oneAction = false;
                        this.nav.toggleLoading(false);
                    });
                } else if (position == "both") {
                    const newBigPoly = new google.maps.Polygon({ paths: poly[0].points });
                    let existingHoles = [];
                    for (let i = 0; i < this.polygons.length; i++) {
                        for (let j = 0; j < this.polygons[i].points.length; j++) {
                            var lat = this.polygons[i].points[j].lat;
                            var lng = this.polygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newBigPoly)) {

                                if (existingHoles.find(x => x == this.polygons[i].id)) {
                                } else {
                                    if (this.polygons[i].id != poly[0].id) {
                                        existingHoles.push(this.polygons[i].id);
                                    }
                                }
                            }
                        }


                    }
                    let counter = 0;
                    for (let i = 0; i < poly.length; i++) {
                        let multiPoly: MultiPolygonField;
                        multiPoly = {
                            fieldId: poly[i].id,
                            smallField: polygon.fieldId,
                            multipleFields: false,
                            edit: polygon.edit,
                            polygon: polygon.polygon,
                            originalPolygon: null,
                            tenantId: this.tenantId,
                            farmId: this.farmId,
                            loadingUser: this.userId
                        }
                        this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            counter++;
                            if (counter == poly.length) {
                                let multiPoly: MultiPolygonField;
                                multiPoly = {
                                    fieldId: polygon.fieldId,
                                    smallField: poly1,
                                    edit: polygon.edit,
                                    polygon: polygon.polygon,
                                    originalPolygon: null,
                                    multipleFields: true,
                                    tenantId: this.tenantId,
                                    farmId: this.farmId,
                                    loadingUser: this.userId
                                }
                                this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                                    // this.overlayBoundary(this.farmId, this.farmName, 0);
                                    this.focusBoundingBox();
                                    this.nav.toggleLoading(false);
                                    this.optionsReached = false;
                                    this.isDrawingMode = false;
                                    this.splitField = false;
                                    this.oneAction = false;
                                });
                            }
                        });
                    }
                }
            } else if (result.result == 0) {
                this.nav.toggleLoading(false);
                this.openSnackBar(this.translate.instant("MAPPING.ADD-FIELD-ERROR"), this.translate.instant("SNACKBAR.DISMISS"));
                this.isDrawingMode = false
                if (drawingManager != null) {
                    // this.drawingManager.setMap(null);
                    event.overlay.setMap(null);
                } else if (this.editablePolygon != null) {
                    this.editablePolygon.setMap(null);
                    if (this.polygon != null) {
                        this.polygon.overlay.setMap(null);
                    }
                }
            }
        });
        this.nav.toggleLoading(false);
    }

    updatePolygonFieldWithoutRefresh(polygon, drawingManager, event) {
        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe((result) => {
            if (result.result == 1) {
            } else if (result.result == 0) {
                this.isDrawingMode = false;
                this.errorUpdating = true;
            }
            this.optionsReached = false;
            this.isDrawingMode = false;
            this.splitField = false;
            this.oneAction = false;
            if (drawingManager != null) {
                drawingManager.setMap(null);
                event.overlay.setMap(null);
            } else {
                this.editablePolygon.setMap(null);
                if (this.polygon != null) {
                    this.polygon.overlay.setMap(null);
                }
            }
            this.focusBoundingBox();
            this.enableBackButton();
            this.nav.enableMenu = true;
        });
    }

    updatePolygonFieldByPositionWithoutRefresh(polygon, drawingManager, event, poly, poly1, position, original) {
        polygon.singleField = false;
        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe((result) => {
            this.enableBackButton();
            this.nav.enableMenu = true;
            if (result.result == 1) {
                if (drawingManager != null) {
                    drawingManager.setMap(null);
                    event.overlay.setMap(null);
                } else {
                    this.editablePolygon.setMap(null);
                    if (this.polygon != null) {
                        this.polygon.overlay.setMap(null);
                    }
                }
                this.optionsReached = false;
                this.isDrawingMode = false;
                this.splitField = false;
                this.oneAction = false;
                if (position == "inside") {
                    const newBigPoly = new google.maps.Polygon({ paths: poly[0].points });
                    let existingHoles = [];
                    for (let i = 0; i < this.polygons.length; i++) {
                        for (let j = 0; j < this.polygons[i].points.length; j++) {
                            var lat = this.polygons[i].points[j].lat;
                            var lng = this.polygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newBigPoly)) {
                                if (existingHoles.find(x => x == this.polygons[i].id)) {
                                } else {
                                    if (this.polygons[i].id != poly[0].id) {
                                        existingHoles.push(this.polygons[i].id);
                                    }
                                }
                            }
                        }
                    }
                    let countProgress = 0;
                    for (let i = 0; i < poly.length; i++) {
                        let multiPoly: MultiPolygonField;
                        multiPoly = {
                            fieldId: poly[0].id,
                            smallField: polygon.fieldId,
                            multipleFields: false,
                            edit: polygon.edit,
                            polygon: polygon.polygon,
                            originalPolygon: original,
                            tenantId: this.tenantId,
                            farmId: this.farmId,
                            loadingUser: this.userId
                        }
                        this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            countProgress++;
                            if (countProgress == poly.length) {
                                this.focusBoundingBox();
                                // this.overlayBoundary(this.farmId, this.farmName, 0);
                            }
                        });
                    }
                } else if (position == "outside") {
                    let multiPoly: MultiPolygonField;
                    multiPoly = {
                        fieldId: polygon.fieldId,
                        smallField: poly,
                        multipleFields: true,
                        edit: polygon.edit,
                        polygon: polygon.polygon,
                        originalPolygon: original,
                        tenantId: this.tenantId,
                        farmId: this.farmId,
                        loadingUser: this.userId
                    }
                    this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                        // this.overlayBoundary(this.farmId, this.farmName, 0);
                       this.focusBoundingBox();
                    });
                } else if (position == "both") {
                    const newBigPoly = new google.maps.Polygon({ paths: poly[0].points });
                    let existingHoles = [];
                    for (let i = 0; i < this.polygons.length; i++) {
                        for (let j = 0; j < this.polygons[i].points.length; j++) {
                            var lat = this.polygons[i].points[j].lat;
                            var lng = this.polygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newBigPoly)) {
                                if (existingHoles.find(x => x == this.polygons[i].id)) {
                                } else {
                                    if (this.polygons[i].id != poly[0].id) {
                                        existingHoles.push(this.polygons[i].id);
                                    }
                                }
                            }
                        }
                    }
                    let countProgress = 0;
                    for (let i = 0; i < poly.length; i++) {
                        let multiPoly: MultiPolygonField;
                        multiPoly = {
                            fieldId: poly[i].id,
                            smallField: polygon.fieldId,
                            multipleFields: false,
                            edit: polygon.edit,
                            polygon: polygon.polygon,
                            originalPolygon: original,
                            tenantId: this.tenantId,
                            farmId: this.farmId,
                            loadingUser: this.userId
                        }

                        this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            countProgress++;
                            if (countProgress == poly.length) {
                              this.focusBoundingBox();
                            }
                        });
                        if (i == poly.length) {
                            let multiPoly: MultiPolygonField;
                            multiPoly = {
                                fieldId: polygon.fieldId,
                                smallField: poly1,
                                multipleFields: true,
                                edit: polygon.edit,
                                polygon: polygon.polygon,
                                originalPolygon: original,
                                tenantId: this.tenantId,
                                farmId: this.farmId,
                                loadingUser: this.userId
                            }
                            this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                                this.focusBoundingBox();
                            });
                        }
                    }
                }
            } else if (result.result == 0) {
                this.isDrawingMode = false;
                this.errorUpdating = true;
                // this.openSnackBar(this.translate.instant("MAPPING.ADD-FIELD-ERROR"), this.translate.instant("SNACKBAR.DISMISS"));
                if (drawingManager != null) {
                    event.overlay.setMap(null);
                } else {
                    this.editablePolygon.setMap(null);
                    if (this.polygon != null) {
                        this.polygon.overlay.setMap(null);
                    }
                }
            }
        });
    }

    editFields(map: GoogleMap) {

        if (this.saveFields || this.isDrawingMode || this.editing || this.editingFields || this.polygons.length == 0) {
            this.openSnackBar(this.translate.instant("MAPPING.FINISH-EDITING"), this.translate.instant("SNACKBAR.DISMISS"));
        } if(this.openVardaBoundary && this.vardaField?.getPath()) {
            this.openSnackBar(this.translate.instant("MAPPING.VARDA-BOUNDARY"), this.translate.instant("SNACKBAR.DISMISS"));
        } else {
          this.openVardaBoundary = false;
            this.action = this.editingAll;
            this.disableBackButton();
            this.nav.enableMenu = false;
            this.editingFields = true;
            if (this.polygons.length > 0) {
                this.oneAction = true;
            }
            this.polygonOptions = {
                editable: true,
                fillOpacity: 0.2
            }
            this.singlePolygon = {
                editable: false,
                fillOpacity: 0.0
            }
            this.editablePolygons = this.polygons;
            this.editablePolygons.sort((a, b) => b.size - a.size);
            this.originalPolygons = this.polygons;
            this.polygons = [];
            this.editablePolygons.forEach((poly) => {

                this.editablePolygon = new google.maps.Polygon({
                    // paths: poly.points[0],
                    map: map.googleMap,
                    options: this.polygonOptions
                });

                if (poly.points[0] > 1) {
                    this.editablePolygon.setPaths(poly.points[0]);

                    for (let i = 1; i < poly.points.length; i++) {
                        let interior = new google.maps.Polygon({
                            paths: poly.points[i],
                            map: map.googleMap,
                            options: this.singlePolygon
                        });
                        this.polygonInteriors.push(interior);
                    }
                } else {
                    this.editablePolygon.setPaths(poly.points);
                }
                this.newPolygons.push(this.editablePolygon);
                this.editablePolygon.getPaths().forEach((path) => {
                    google.maps.event.addListener(path, 'insert_at', (event) => {
                        this.saveFields = true;
                        poly.changed = true;
                        poly.points = path;
                    });

                    google.maps.event.addListener(path, 'remove_at', (event) => {
                        this.saveFields = true;
                        poly.changed = true;
                        poly.points = path;
                    });

                    google.maps.event.addListener(path, 'set_at', (event) => {
                        this.saveFields = true;
                        poly.changed = true;
                        poly.points = path;
                    });
                });
            });
        }
    }

    updateFields() {
        this.isOpen = false;
        this.nav.toggleLoading(true);

        this.errorUpdating = false;
        this.newPolygons.forEach((poly1) => {
            poly1.setMap(null);
        });
        this.newPolygons = [];
        this.addedPolygons.forEach((poly1) => {
            poly1.setMap(null);
        });
        this.polygonInteriors.forEach((poly1) => {
            poly1.setMap(null);
        });
        this.polygonInteriors = [];
        this.addedPolygons = [];
        this.enableBackButton();
        this.nav.enableMenu = true;
        this.editingFields = false;
        this.editing = false;
        this.saveFields = false;
        this.polygonOptions = {
            editable: false,
            fillOpacity: 0.0
        }
        this.singlePolygon = {
            editable: false,
            fillOpacity: 0.0
        }
        this.oneAction = false;
        this.editedPolygons = [];
        let count = 0;
        this.editablePolygons.forEach((poly) => {
            let index = this.editablePolygons.indexOf(poly);
            if (poly.changed) {
                this.editedPolygons.push(poly);
                this.editedOriginals.push(this.originalPolygons[index]);
            } else {
                this.polygons.push(poly);
            }
            count++;
            if (this.editablePolygons.length == count) {
                let newCounter = 1;
                this.editedPolygons.forEach((edited) => {
                    let newIndex = this.editedPolygons.indexOf(edited);
                    if (this.editedOriginals[0] != null) {
                        let original = new google.maps.Polygon({
                            paths: this.editedOriginals[newIndex].points,
                            map: null,
                            options: this.polygonOptions
                        });
                        var encodedOriginal = google.maps.geometry.encoding.encodePath(original.getPath());
                    }

                    var encodedPoly = google.maps.geometry.encoding.encodePath(edited.points.getArray());
                    let inside: boolean = false;
                    let outside: boolean = false;
                    let insidePoly = [];
                    let outsidePoly = [];
                    let indentInside = [];
                    let indentOutside = [];
                    let polyArray = edited.points;
                    const newPoly = new google.maps.Polygon({ paths: polyArray });
                    for (let i = 0; i < this.polygons.length; i++) {
                        const exixtingPoly = new google.maps.Polygon({ paths: this.polygons[i].points });
                        var newPolyArray = edited.points.getArray();
                        for (let j = 0; j < newPolyArray.length; j++) {
                            // newPolyArray.forEach(element => {
                            if (google.maps.geometry.poly.containsLocation(newPolyArray[j], exixtingPoly)) {
                                indentInside.push(true);
                                inside = true;
                                if (insidePoly.find(x => x.id == this.polygons[i].id)) {
                                } else {
                                    insidePoly.push(this.polygons[i]);
                                }
                            }
                            // });
                        }
                        for (let j = 0; j < this.polygons[i].points.length; j++) {
                            var lat = this.polygons[i].points[j].lat;
                            var lng = this.polygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newPoly)) {
                                indentOutside.push(true);
                                outside = true;
                                if (outsidePoly.find(x => x == this.polygons[i].id)) {
                                } else {
                                    outsidePoly.push(this.polygons[i].id);
                                }
                            }
                        }
                    }

                    let polygon: Polygon = {
                        polygon: encodedPoly,
                        interiorPolygons: null,
                        fieldId: edited.id,
                        edit: true,
                        singleField: true,
                        tenantId: this.tenantId,
                        farmId: this.farmId,
                        loadingUser: this.userId

                    }
                    if (inside && outside) {
                        this.updatePolygonFieldByPositionWithoutRefresh(polygon, null, null, insidePoly, outsidePoly, "both", encodedOriginal);
                    } else if (inside) {
                        this.updatePolygonFieldByPositionWithoutRefresh(polygon, null, null, insidePoly, null, "inside", encodedOriginal);
                    } else if (outside) {
                        this.updatePolygonFieldByPositionWithoutRefresh(polygon, null, null, outsidePoly, null, "outside", encodedOriginal);
                    } else {
                        this.updatePolygonFieldWithoutRefresh(polygon, null, null);
                    }

                    if (newCounter == this.editedPolygons.length) {
                        setTimeout(() => {
                            this.overlayBoundary(this.farmId, this.farmName, 0);
                            if (this.errorUpdating) {
                                this.nav.toggleLoading(false);
                                this.openSnackBar(this.translate.instant("MAPPING.ADD-FIELD-ERROR"), this.translate.instant("SNACKBAR.DISMISS"));
                            } else {
                                this.nav.toggleLoading(false);
                                this.openSnackBar(this.translate.instant("MAPPING.CHANGES-SAVED"), this.translate.instant("SNACKBAR.DISMISS"));
                            }

                        }, 5000);
                    }
                    newCounter++;
                });
                // if (this.splitField) {
                //     this.initDrawingManager(this.map, this.splitFieldName);
                //     this.stillDrawing = true;
                //     this.oneAction = true;
                //     this.action = this.drawing + ": " + this.splitFieldName;
                // }
            }
        });
    }

    stopAddingField() {

        const dialogRef = this.dialog.open(StopDrawingComponent, {
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.option === 'ok') {
                this.clearDrawnMarkers();
                this.clearCircleDrawing();
                if (this.previewPolyline) {
                    this.previewPolyline.setMap(null);
                    this.previewPolyline = null;
                }
                if (this.previewPolygon) {
                    this.previewPolygon.setMap(null);
                    this.previewPolygon = null;
                }
                this.isDrawingMode = false;
                this.drawnPoints = [];
                this.newFieldName = '';
                this.oneAction = false;
                this.enableBackButton();
                this.nav.enableMenu = true;
                this.agmMap?.googleMap?.setOptions({ draggableCursor: null });
            }
        });
        this.openOptions();
    }

    addDrawingPoint(latLng: google.maps.LatLngLiteral) {
        const SNAP_TOLERANCE = 0.00001;

        const snappedPoint = this.drawnPoints.find(p =>
            Math.abs(p.lat - latLng.lat) < SNAP_TOLERANCE &&
            Math.abs(p.lng - latLng.lng) < SNAP_TOLERANCE
        );

        const pointToAdd = snappedPoint ?? latLng;
        this.drawnPoints.push(pointToAdd);

        const isFirstPoint = this.drawnPoints.length === 1;
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: pointToAdd,
            map: this.agmMap.googleMap,
            content: this.createCircleMarkerContent(
                isFirstPoint ? 8 : 6,
                isFirstPoint ? '#FF6B00' : '#ffffff',
                1,
                '#000000',
                2
            ),
            zIndex: 9999
        });

        if (isFirstPoint) {
            (marker.content as HTMLElement).addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.drawnPoints.length >= 3) {
                    this.finishCustomDrawing();
                }
            });
        }
        this.drawnMarkers.push(marker);
        this.updatePreview();
    }

    updatePreviewLine(latLng: google.maps.LatLngLiteral) {
        const lastPoint = this.drawnPoints[this.drawnPoints.length - 1];

        if (this.previewLine) {
            this.previewLine.setPath([lastPoint, latLng]);
        } else {
            this.previewLine = new google.maps.Polyline({
                path: [lastPoint, latLng],
                map: this.agmMap.googleMap,
                strokeColor: '#000000',
                strokeOpacity: 0.6,
                strokeWeight: 2,
                clickable: false,
                zIndex: -1
            });
        }
    }

    clearDrawnMarkers() {
        this.drawnMarkers.forEach(m => m.map = null);
        this.drawnMarkers = [];
        if (this.previewLine) {
            this.previewLine.setMap(null);
            this.previewLine = null;
        }
    }

    undoLastPoint() {
        if (this.drawnPoints.length > 0) {
            this.drawnPoints = this.drawnPoints.slice(0, -1);
            const lastMarker = this.drawnMarkers.pop();
            if (lastMarker) lastMarker.map = null;
            if (this.drawnPoints.length < 3 && this.previewPolygon) {
                this.previewPolygon.setMap(null);
                this.previewPolygon = null;
            }
            this.updatePreview();
        }
    }

    finishCustomDrawing() {
        if (this.drawingType === 'circle') {
            this.finishCircleDrawing();
            return;
        }

        if (this.drawnPoints.length < 3) {
            this.openSnackBar('Please add at least 3 points', this.translate.instant("SNACKBAR.DISMISS"));
            return;
        }

    this.agmMap.googleMap.setOptions({ draggableCursor: null });

    const dialogRef = this.dialog.open(NewFieldComponent, { data: {} });

    dialogRef.afterClosed().subscribe(result => {
        if (!result || result.option === 'cancel') {
            this.agmMap.googleMap.setOptions({ draggableCursor: 'crosshair' });
            return;
        }

        if (result.option === 'redraw') {
            this.clearDrawnMarkers();
            if (this.previewPolyline) { this.previewPolyline.setMap(null); this.previewPolyline = null; }
            if (this.previewPolygon) { this.previewPolygon.setMap(null); this.previewPolygon = null; }
            this.drawnPoints = [];
            this.isDrawingMode = true;
            this.oneAction = true;
            this.action = this.drawing + ': ' + this.newFieldName;
            this.agmMap.googleMap.setOptions({ draggableCursor: 'crosshair' });
            return;
        }

        if (result.option === 'edit') {
            this.isDrawingMode = false;
            this.clearDrawnMarkers();
            if (this.previewPolyline) { this.previewPolyline.setMap(null); this.previewPolyline = null; }
            if (this.previewPolygon) { this.previewPolygon.setMap(null); this.previewPolygon = null; }
            this.editNewField(this.agmMap, this.drawnPoints, false);

            this.oneAction = true;
            this.action = this.busyEditing + ": " + this.newFieldName;
            this.disableBackButton();
            this.nav.enableMenu = false;
            return;
        }

        if (result.option === 'add') {
        this.isDrawingMode = false;
        this.agmMap.googleMap.setOptions({ draggableCursor: null });

        this.clearDrawnMarkers();
        if (this.previewPolyline) { this.previewPolyline.setMap(null); this.previewPolyline = null; }
        if (this.previewPolygon) { this.previewPolygon.setMap(null); this.previewPolygon = null; }

        const encodedPath = google.maps.geometry.encoding.encodePath(
            this.drawnPoints.map(p => new google.maps.LatLng(p.lat, p.lng))
        );

        this.nav.toggleLoading(true);

        const addField: AddField = {
            name: this.newFieldName,
            farmId: this.farmId,
            userId: this.userId
        };

        this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
            const overlayPath = this.drawnPoints.map(p => new google.maps.LatLng(p.lat, p.lng));

            let inside = false;
            let outside = false;
            let insidePoly = [];
            let outsidePoly = [];
            const newPoly = new google.maps.Polygon({ paths: overlayPath });

            for (let i = 0; i < this.polygons.length; i++) {
                const existingPoly = new google.maps.Polygon({ paths: this.polygons[i].points });

                for (let j = 0; j < overlayPath.length; j++) {
                    if (google.maps.geometry.poly.containsLocation(overlayPath[j], existingPoly)) {
                        inside = true;
                        if (!insidePoly.find(x => x.id == this.polygons[i].id)) {
                            insidePoly.push(this.polygons[i]);
                        }
                    }
                }

                for (let j = 0; j < this.polygons[i].points.length; j++) {
                    const latLng = new google.maps.LatLng(
                        this.polygons[i].points[j].lat,
                        this.polygons[i].points[j].lng
                    );
                    if (google.maps.geometry.poly.containsLocation(latLng, newPoly)) {
                        outside = true;
                        if (!outsidePoly.find(x => x == this.polygons[i].id)) {
                            outsidePoly.push(this.polygons[i].id);
                        }
                    }
                }
            }

            const polygon: Polygon = {
                polygon: encodedPath,
                interiorPolygons: null,
                fieldId: result.id,
                edit: false,
                singleField: true,
                tenantId: this.tenantId,
                farmId: this.farmId,
                loadingUser: this.userId
            };

            if (inside && outside) {
                this.updatePolygonFieldByPosition(polygon, null, null, insidePoly, outsidePoly, 'both');
            } else if (inside) {
                this.updatePolygonFieldByPosition(polygon, null, null, insidePoly, null, 'inside');
            } else if (outside) {
                this.updatePolygonFieldByPosition(polygon, null, null, outsidePoly, null, 'outside');
            } else {
                this.updatePolygonField(polygon, null, null);
            }

            this.drawnPoints = [];
            this.newFieldName = '';
            this.oneAction = false;
            this.enableBackButton();
            this.nav.enableMenu = true;
            this.nav.toggleLoading(false);
                });
            }
        });
    }

    updatePreview() {
        if (this.previewPolygon) {
            this.previewPolygon.setMap(null);
            this.previewPolygon = null;
        }

        if (this.drawnPoints.length >= 2) {
            const path = this.drawnPoints.map(p => new google.maps.LatLng(p.lat, p.lng));

            if (this.previewPolyline) {
                this.previewPolyline.setMap(null);
                this.previewPolyline = null;
            }

            this.previewPolyline = new google.maps.Polyline({
                path: path,
                strokeColor: this.fieldBoundaryEditColor,
                strokeWeight: 3,
                map: this.agmMap.googleMap
            });
        } else {
            if (this.previewPolyline) {
                this.previewPolyline.setMap(null);
                this.previewPolyline = null;
            }
            if (this.previewLine) {
                this.previewLine.setMap(null);
                this.previewLine = null;
            }
        }
    }

    startCircleDrawing(latLng: google.maps.LatLngLiteral) {
        if (this.circleCenter) return;

        this.circleCenter = latLng;

        // this.circleCenterMarker = new google.maps.Marker({
        //     position: latLng,
        //     map: this.agmMap.googleMap,
        //     draggable: true,
        //     icon: {
        //         path: google.maps.SymbolPath.CIRCLE,
        //         scale: 8,
        //         fillColor: '#FF6B00',
        //         fillOpacity: 1,
        //         strokeColor: '#000000',
        //         strokeWeight: 2,
        //     },
        //     zIndex: 9999
        // });

        this.previewCircle = new google.maps.Circle({
            center: latLng,
            radius: 100,
            strokeColor: this.fieldBoundaryEditColor,
            strokeWeight: 3,
            fillOpacity: 0.2,
            fillColor: this.fieldBoundaryEditColor,
            map: this.agmMap.googleMap,
            editable: true
        });

        google.maps.event.addListener(this.previewCircle, 'center_changed', (e) => {
            this.circleCenter = this.previewCircle.getCenter().toJSON();
        });
    }

    finishCircleDrawing() {
        if (!this.previewCircle || this.previewCircle.getRadius() < 1) {
            this.openSnackBar('Please draw a circle first', this.translate.instant("SNACKBAR.DISMISS"));
            return;
        }

        const radius = Math.round(this.previewCircle.getRadius());
        const center = this.previewCircle.getCenter();

        this.agmMap.googleMap.setOptions({ draggableCursor: null });

        const dialogRef = this.dialog.open(NewFieldComponent, { data: {} });

        dialogRef.afterClosed().subscribe(result => {
            if (!result || result.option === 'cancel') {
                this.agmMap.googleMap.setOptions({ draggableCursor: 'crosshair' });
                return;
            }

            if (result.option === 'redraw') {
                this.clearCircleDrawing();
                this.isDrawingMode = true;
                this.drawingType = 'circle';
                this.oneAction = true;
                this.action = this.drawing + ': ' + this.newFieldName;
                this.drawnPoints = [];
                this.agmMap.googleMap.setOptions({ draggableCursor: 'crosshair' });
                return;
            }

            if (result.option === 'edit') {
                this.isDrawingMode = false;
                this.clearCircleDrawing();
                this.editNewField(this.agmMap, { center: center, radius: radius }, true);
                this.oneAction = true;
                this.action = this.busyEditing + ": " + this.newFieldName;
                this.disableBackButton();
                this.nav.enableMenu = false;
                return;
            }

            if (result.option === 'add') {
                this.isDrawingMode = false;
                this.agmMap.googleMap.setOptions({ draggableCursor: null });

        this.nav.toggleLoading(true);

        const addField: AddField = {
            name: this.newFieldName,
            farmId: this.farmId,
            userId: this.userId
        };

        this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
            const circlePolygon: CirclePolygon = {
                lat: center.lat(),
                lng: center.lng(),
                radius: radius,
                fieldId: result.id,
                tenantId: this.tenantId,
                farmId: this.farmId,
                loadingUser: this.userId
            };

            this.boundaryManagementService.updateCircularField(circlePolygon).subscribe(() => {
                this.clearCircleDrawing();
                this.drawnPoints = [];
                this.newFieldName = '';
                this.drawingType = null;
                this.isDrawingMode = false;
                this.oneAction = false;
                this.enableBackButton();
                this.nav.enableMenu = true;
                this.agmMap.googleMap.setOptions({ draggableCursor: null });
                this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));

                this.farmManagementService.getFarmBoundingBox(this.farmId).subscribe({
                    next: (boundingBox) => {
                        this.farmBounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1),
                            new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2)
                        );
                        this.overlayBoundary(this.farmId, this.farmName, 0);
                        this.nav.toggleLoading(false);
                    },
                    error: () => {
                        this.overlayBoundary(this.farmId, this.farmName, 0);
                        this.nav.toggleLoading(false);
                    }
                });
            });
        });
    }
        });
    }

    clearCircleDrawing() {
        if (this.circleListeners) {
            this.circleListeners.forEach(l => google.maps.event.removeListener(l));
            this.circleListeners = [];
        }
        if (this.previewCircle) {
            this.previewCircle.setMap(null);
            this.previewCircle = null;
        }
        if (this.circleCenterMarker) {
            this.circleCenterMarker.map = null;
            this.circleCenterMarker = null;
        }
        this.circleCenter = null;
        this.isDraggingCircle = false;
        this.clearDrawnMarkers();
    }

    stopEditing() {

        if (this.saveFields) {
            const dialogRef = this.dialog.open(SaveChangesComponent, {
                data: {}
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result != null) {
                    if (result.option == "save") {
                        this.updateFields();
                        this.oneAction = false;
                    } else {
                        this.enableBackButton();
                        this.oneAction = false;
                        this.nav.enableMenu = true;
                        this.editing = false;
                        this.editingFields = false;
                        this.saveFields = false;
                        this.newPolygons.forEach((poly) => {
                            poly.setMap(null);
                        });
                        this.addedPolygons.forEach((poly1) => {
                            poly1.setMap(null);
                        });
                        this.polygonInteriors.forEach((poly1) => {
                            poly1.setMap(null);
                        });
                        this.polygonOptions = {
                            editable: false,
                            fillOpacity: 0.0
                        }
                        this.overlayBoundary(this.farmId, this.farmName, 0);
                    }
                }
            });
        } else {
            this.enableBackButton();
            this.nav.enableMenu = true;
            this.editingFields = false;
            this.editing = false;
            this.saveFields = false;
            this.oneAction = false;
            this.newPolygons.forEach((poly) => {
                poly.setMap(null);
            });
            this.addedPolygons.forEach((poly1) => {
                poly1.setMap(null);
            });
            this.polygonInteriors.forEach((poly1) => {
                poly1.setMap(null);
            });
            this.polygonOptions = {
                editable: false,
                fillOpacity: 0.0
            }
            this.overlayBoundary(this.farmId, this.farmName, 0);
        }
        this.openOptions();
    }

    getVardaBoundary(event: google.maps.MapMouseEvent, map: GoogleMap) {

        if (this.isDrawingMode && this.drawingType === 'polygon') {
            this.finishCustomDrawing();
            return;
        }

        //console.log('getVardaBoundary called', this.isDrawingMode, this.drawingType);

        if (this.isDrawingMode && this.drawingType === 'polygon') {
            this.addDrawingPoint(event.latLng.toJSON());
            return;
        }
        if (this.isDrawingMode && this.drawingType === 'circle') {
            this.startCircleDrawing(event.latLng.toJSON());
            return;
        }

      if(this.openVardaBoundary && !this.vardaField?.getPath()) {
        let latlng = event.latLng.toJSON();
        if(this.vardaField) {
          this.vardaField.setMap(null);
        }

        this.nav.toggleLoading(true);

        this.vardaService.getVardaBoundaries(latlng).subscribe({
          next: (res) => {
            this.nav.toggleLoading(false);

            if(res?.features?.length > 0) {
              let polygon = res?.features[0]?.geometry?.coordinates;
              let points = [];

              for(let firstArray of polygon) {
                for(let secondArray of firstArray) {
                  for(let thirdArray of secondArray) {
                    points.push({
                      lat: thirdArray[1],
                      lng: thirdArray[0]
                    });
                  }
                  break;
                }
              }

              this.vardaField = new google.maps.Polygon({
                map: map.googleMap,
                paths: points,
                strokeColor: this.fieldBoundaryColor,
                strokeOpacity: 0.8,
                strokeWeight: 4,
                fillColor: this.fieldBoundaryColor,
                fillOpacity: 0.35,
                editable: true
              });

              const path = this.vardaField.getPath();

              this.vardaFieldSize = google.maps.geometry.spherical.computeArea(path) / 10000;

              google.maps.event.addListener(path, 'set_at', () => {
                this.vardaFieldSize = google.maps.geometry.spherical.computeArea(path) / 10000;
              });

              google.maps.event.addListener(path, 'insert_at', () => {
                this.vardaFieldSize = google.maps.geometry.spherical.computeArea(path) / 10000;
              });

            } else {
              this.openSnackBar('No Boundary available', this.translate.instant("SNACKBAR.DISMISS"));
            }
          },
          error: (err) => {
            this.openSnackBar('Failed to load field boundary', this.translate.instant("SNACKBAR.DISMISS"));
            this.nav.toggleLoading(false);
          }
        })
      }
    }

    onMapClick(event: google.maps.MapMouseEvent) {
      // Check if we're viewing a profitability map
      if (this.selectedMapTitleDetails?.type?.toLowerCase().includes('profitability') && this.activeHistoryId) {
        const latLng = event.latLng.toJSON();

        this.analysisManagementService.getProfitabilityPolygonPoint(
          this.activeHistoryId,
          latLng.lng,
          latLng.lat
        ).subscribe({
          next: (data) => {
            this.showProfitabilityDialog(data);
          },
          error: (err) => {
            console.error('Error fetching profitability data:', err);
          }
        });
      }
    }

    showProfitabilityDialog(data: any) {
      const message = `
        Polygon ID: ${data.polygonId}
        Profitability Value: R${data.profitabilityValue?.toFixed(2)}
        Yield Per Polygon: ${data.yieldPerPolygon?.toFixed(2)} tons
        Input Cost Per Polygon: R${data.inputCostPerPolygon?.toFixed(2)}
        Polygon Area: ${data.polygonAreaM2?.toFixed(2)} m²
      `;

      this.openSnackBar(message, 'Close');
    }

    clearVardaBoundary() {
      if(this.vardaField) {
        this.vardaField.setMap(null);
        this.vardaField = null;
      }
      this.vardaFieldSize = 0;
    }

    saveVardaBoundary() {
      if(this.vardaField?.getPath()) {
        const dialogRef = this.dialog.open(AddFieldComponent, {
          data: { farmId: this.farmId },
          maxWidth: "100%",
          minWidth: "23%"
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result?.option === 'add') {
            let userId = this.helper.getUserId();
            let addField: AddField = {
              name: result.fieldName,
              farmId: this.farmId,
              userId: userId
            }

            this.boundaryManagementService.insertFieldName(addField).subscribe({
              next: (result) => {
                let polygon: Polygon = {
                  polygon: google.maps.geometry.encoding.encodePath(this.vardaField.getPath()),
                  interiorPolygons: null,
                  fieldId: result.id,
                  edit: false,
                  singleField: true,
                  tenantId: this.tenantId,
                  farmId: this.farmId,
                  loadingUser: this.userId
                }

                this.vardaFieldSize = 0;

                this.updatePolygonField(polygon, null, null);
              }
            });
          }
        })
      }
    }

    openDeleteFieldDialog(field: Field, farmIndex) {
      this.farmIndex = farmIndex;
      const dialogRef = this.dialog.open(DeleteFieldComponent, {
        data: {}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != null) {
          if (result.option == "delete") {
            this.checkFieldPosition(field);
            this.optionsReached = false;
          } else if (result.option == "cancel") {
            this.optionsReached = false;
          }
        }
      });
    }

    openSplitFieldDialog(fieldId, fieldName, map) {
      const dialogRef = this.dialog.open(EditFieldComponent, {
        data: {},
        maxWidth: "100%",
        minWidth: "23%"
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != null) {
          if (result.option == "change") {
            this.editingFields = true;
            this.editField(fieldId, map);
            this.oneAction = true;
            this.action = this.busyEditing + ": " + fieldName;
            this.splitField = true;
            this.splitFieldName = result.fieldName;
            this.map = map;
          } else if (result.option == "cancel") {
            this.optionsReached = false;
          }
        }
      });
    }

    // fieldOptions(fieldName, fieldId, map: GoogleMap) {
    //     this.nav.toggleLoading(true);
    //     this.optionsReached = true;
    //     const dialogRef = this.dialog.open(FieldOptionsComponent, {
    //         data: {
    //             fieldNameDisplayed: fieldName,
    //         }
    //     });
    //
    //     dialogRef.afterClosed().subscribe(result => {
    //         if (result != null) {
    //             if (result.option == "delete") {
    //                 this.openDeleteFieldDialog(fieldId);
    //             } else if (result.option == "changeName") {
    //                 this.openChangeNameDialog(fieldId, fieldName)
    //             } else if (result.option == "splitField") {
    //                 this.openSplitFieldDialog(fieldId, fieldName, map);
    //             } else if (result.option == "cancel") {
    //                 this.optionsReached = false;
    //             }
    //         }
    //     });
    //     this.nav.toggleLoading(false);
    // }

    openFarmNameEditor(farm: Farm) {
        if (this.showOptions) {
            setTimeout(() => {
                this.showOptions = false
            }, 2000);
        }
        const id = farm.id;
        const name = farm.name;
        const dialogRef = this.dialog.open(RenameFarmComponent, {
            data: { id, name }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                //  Refresh get farm method only after name update to refresh view
                this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
                    if (farms != null) {
                        farms.sort((a, b) => a.name.localeCompare(b.name));
                        this.filteredFarms = farms;
                        this.farms = farms;
                        this.farmSubjects.next(farms);
                        let jsonFarms = JSON.stringify(farms);
                        sessionStorage.setItem("farms", jsonFarms);
                    }
                });
            }

        });
    }

    deleteField(field: Field) {
        this.nav.toggleLoading(true);
        let fieldID: FieldId = {
            fieldId: field.id,
            tenantId: this.tenantId,
            farmId: this.farmId,
            loadingUser: this.userId
        }
        this.boundaryManagementService.deleteField(fieldID).subscribe((result) => {
            this.openSnackBar(this.translate.instant("MAPPING.FIELD-DELETED"), this.translate.instant("SNACKBAR.DISMISS"));
            this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
                this.nav.toggleLoading(false);
                this.agmMap.zoom = this.minMapZoom;
                this.agmMap.panTo(this.center);
                if (farms != null) {
                    farms.sort((a, b) => a.name.localeCompare(b.name));
                    this.filteredFarms = farms;
                    this.farms = farms;
                    this.farmSubjects.next(farms);
                    let jsonFarms = JSON.stringify(farms);
                    sessionStorage.setItem("farms", jsonFarms);
                } else {
                    this.openSnackBar(this.translate.instant("MAPPING.TENANT-NO-FARMS"), this.translate.instant("SNACKBAR.DISMISS"));
                }
                this.focusBoundingBox();
                this.nav.toggleLoading(false);
            });
        });
    }

    checkFieldPosition(field: Field) {
        this.nav.toggleLoading(true);


        let inside: boolean = false;
        let insidePoly = [];
        let path;
        let newArray = [];
        let newCount = 0;
        for (let y = 0; y < this.polygons.length; y++) {
            if (this.polygons[y].id == field.id) {

                path = this.polygons[y];
            } else {
                newArray.push(this.polygons[y]);
            }
            newCount++;


            if (newCount == this.polygons.length) {
                const newPoly = new google.maps.Polygon({ paths: path.points });


                for (let i = 0; i < newArray.length; i++) {
                    const exixtingPoly = new google.maps.Polygon({ paths: newArray[i].points });
                    var newPolyArray = newPoly.getPath().getArray();
                    for (let j = 0; j < newPolyArray.length; j++) {
                        if (google.maps.geometry.poly.containsLocation(newPolyArray[j], exixtingPoly)) {

                            inside = true;
                            if (insidePoly.find(x => x == newArray[i].id)) {
                            } else {
                                insidePoly.push(newArray[i].id);
                            }
                        }
                    }
                }
            }
        }
        if (inside) {
            let results = [];
            let counter = 1;
            let contains = [];
            let indents = [];
            for (let i = 0; i < insidePoly.length; i++) {
                this.boundaryManagementService.getIntersectType(insidePoly[i], field.id).subscribe((result) => {
                    if (result.result) {
                        contains.push(insidePoly[i]);
                    } else {
                        indents.push(insidePoly[i]);
                    }
                    results.push(result.result);
                    if (counter == insidePoly.length) {
                        if (results.find(x => x == true) || results.find(y => y == null)) {
                            this.deleteInside(field, contains, indents);
                        } else {
                            this.deleteIndent(field, contains, indents);
                        }
                    }
                    counter++;
                });
            }
        } else {
            this.deleteField(field);
        }
        this.nav.toggleLoading(false);
    }

    deleteIndent(currentField: Field, contains, indents) {

        const dialogRef = this.dialog.open(DeleteIndentFieldComponent, {
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                if (result.option == "delete") {
                    let field: ContaningField = {
                        fieldId: currentField.id,
                        contains: contains[0],
                        indents: indents,
                        tenantId: this.tenantId,
                        farmId: this.farmId,
                        loadingUser: this.userId
                    }
                    this.boundaryManagementService.restoreContainingFields(field).subscribe((result) => {
                    });
                } else if (result.option == "cancel") {
                    this.optionsReached = false;
                }
            }
            this.deleteField(currentField);
        });
    }

    deleteInside(currentField: Field, contains, indents) {

        const dialogRef = this.dialog.open(DeleteInsideFieldComponent, {
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                if (result.option == "delete") {
                    let field: ContaningField = {
                        fieldId: currentField.id,
                        contains: contains[0],
                        indents: indents,
                        tenantId: this.tenantId,
                        farmId: this.farmId,
                        loadingUser: this.userId
                    }
                    this.boundaryManagementService.restoreContainingFields(field).subscribe((result) => {
                    });
                } else if (result.option == "cancel") {
                    this.optionsReached = false;
                }
            }
            this.deleteField(currentField);
        });
    }

    editField(fieldId, map: GoogleMap) {

        this.disableBackButton();
        this.nav.enableMenu = false;
        this.editing = true;
        this.polygonOptions = {
            strokeColor: this.fieldBoundaryColor,
            strokeWeight: 4,
            fillOpacity: 0.0,
            editable: false
        }
        this.singlePolygon = {
            strokeColor: this.fieldBoundaryColor,
            strokeWeight: 4,
            fillOpacity: 0.0,
            editable: true
        }
        this.editablePolygons = this.polygons;
        this.polygons = [];
        let index;
        for (let i = 0; i < this.editablePolygons.length; i++) {
            if (this.editablePolygons[i].id == fieldId) {
                this.editablePolygon = new google.maps.Polygon({
                    // paths: [this.editablePolygons[i].points],
                    map: map.googleMap,
                    options: this.singlePolygon
                });
                if (this.editablePolygons[i].points[0].length > 1) {
                    this.editablePolygon.setPaths(this.editablePolygons[i].points[0]);
                    for (let x = 1; x < this.editablePolygons[i].points.length; x++) {
                        let interior = new google.maps.Polygon({
                            paths: this.editablePolygons[i].points[x],
                            map: map.googleMap,
                            options: this.polygonOptions
                        });
                        this.polygonInteriors.push(interior);
                    }
                } else {
                    this.editablePolygon.setPaths(this.editablePolygons[i].points);
                }
                index = i;
                this.originalPolygon = this.editablePolygons[i].points;

                this.newPolygons.push(this.editablePolygon);
                let path = this.editablePolygon.getPath();
                google.maps.event.addListener(path, 'insert_at', (event) => {
                    this.saveFields = true;
                    this.editablePolygons[index].changed = true;
                    this.editablePolygons[index].points = path;
                });

                google.maps.event.addListener(path, 'remove_at', (event) => {
                    this.saveFields = true;
                    this.editablePolygons[index].changed = true;
                    this.editablePolygons[index].points = path;
                });

                google.maps.event.addListener(path, 'set_at', (event) => {
                    this.saveFields = true;
                    this.editablePolygons[index].changed = true;
                    this.editablePolygons[index].points = path;
                });
            }
        }
        ;

        this.editablePolygons.forEach((poly) => {
            if (poly.id != fieldId) {
                let polygon = new google.maps.Polygon({
                    paths: poly.points,
                    map: map.googleMap,
                    options: this.polygonOptions
                });
                this.addedPolygons.push(polygon);
            }
        });
    }

    editNewField(map: GoogleMap, shapeData: any, isCircle: boolean = false) {
        this.editing = true;
        this.saveEditedField = true;
        this.isDrawingMode = false;

        this.singlePolygon = {
            strokeColor: this.fieldBoundaryColor,
            strokeWeight: 4,
            fillOpacity: 0.0,
            editable: true,
            draggable: false
        }

        if (isCircle) {
            const center = shapeData.center;
            const radius = shapeData.radius;

            this.editableCircle = new google.maps.Circle({
                center: center,
                radius: radius,
                map: map.googleMap,
                ...this.singlePolygon
            });
            this.originalCircleCenter = { lat: center.lat(), lng: center.lng() };
            this.originalCircleRadius = radius;
            google.maps.event.addListener(this.editableCircle, 'radius_changed', () => {
                this.saveEditedField = true;
            });

            google.maps.event.addListener(this.editableCircle, 'center_changed', () => {
                this.saveEditedField = true;
            });
        } else {
            this.originalDrawnPoints = [...shapeData];

            this.editablePolygon = new google.maps.Polygon({
                paths: shapeData.map(p => new google.maps.LatLng(p.lat, p.lng)),
                map: map.googleMap,
                options: this.singlePolygon
            });

            const path = this.editablePolygon.getPath();

            google.maps.event.addListener(path, 'insert_at', (event) => {
                this.saveEditedField = true;
                this.editablePolygon.setPaths(path);
            });

            google.maps.event.addListener(path, 'remove_at', (event) => {
                this.saveEditedField = true;
                this.editablePolygon.setPaths(path);
            });

            google.maps.event.addListener(path, 'set_at', (event) => {
                this.saveEditedField = true;
                this.editablePolygon.setPaths(path);
            });
        }
    }

    updateEditedField() {

        this.nav.toggleLoading(true);
        var userId = this.helper.getUserId();
        let addField: AddField = {
            name: this.newFieldName,
            farmId: this.farmId,
            userId: userId
        }
        this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
            this.fieldId = result.id;
            if (this.editableCircle != null) {
                let circlePolygon: CirclePolygon = {
                    lat: this.editableCircle.getCenter().lat(),
                    lng: this.editableCircle.getCenter().lng(),
                    radius: Math.round(this.editableCircle.getRadius()),
                    fieldId: this.fieldId,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                }
                this.boundaryManagementService.updateCircularField(circlePolygon).subscribe(() => {
                    this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
                    this.editableCircle.setMap(null);
                    this.editableCircle = null;
                    this.circleCenter = null;
                    this.originalCircleCenter = null;
                    this.originalCircleRadius = null;
                    this.previewCircle = null;
                    this.drawingType = null;

                    this.optionsReached = false;
                    this.isDrawingMode = false
                    this.splitField = false;
                    this.oneAction = false;
                    this.editing = false;
                    this.saveEditedField = false;

                    this.enableBackButton();
                    this.nav.enableMenu = true;
                    this.focusBoundingBox(this.fieldId);
                    this.nav.toggleLoading(false);
                });
            } else if (this.editablePolygon != null) {
                var poly = google.maps.geometry.encoding.encodePath(this.editablePolygon.getPath());
                let inside: boolean = false;
                let outside: boolean = false;
                let insidePoly = [];
                let outsidePoly = [];
                let polygon: Polygon = {
                    polygon: poly,
                    interiorPolygons: null,
                    fieldId: this.fieldId,
                    edit: false,
                    singleField: true,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                }
                this.editing = false;
                this.saveEditedField = false;
                if (inside && outside) {
                    this.updatePolygonFieldByPosition(polygon, null, null, insidePoly, outsidePoly, "both");
                } else if (inside) {
                    this.updatePolygonFieldByPosition(polygon, null, null, insidePoly, null, "inside");
                } else if (outside) {
                    this.updatePolygonFieldByPosition(polygon, null, null, outsidePoly, null, "outside");
                } else {
                    this.updatePolygonField(polygon, null, null);
                }

                this.editablePolygon.setMap(null);
                this.editablePolygon = null;
            }
        });
        this.nav.toggleLoading(false);
    }

    cancelEdit() {
    const dialogRef = this.dialog.open(StopDrawingComponent, {
        data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
        if (result?.option === 'ok') {
            this.nav.toggleLoading(true);
        if (this.editablePolygon) {
            this.editablePolygon.setMap(null);
            this.editablePolygon = null;
        }

        if (this.editableCircle) {
            this.editableCircle.setMap(null);
            this.editableCircle = null;
        }
                this.clearCircleDrawing();
                this.clearDrawnMarkers();

                if (this.previewPolyline) {
                    this.previewPolyline.setMap(null);
                    this.previewPolyline = null;
                }

                if (this.previewPolygon) {
                    this.previewPolygon.setMap(null);
                    this.previewPolygon = null;
                }

                this.drawnPoints = [];
                this.originalDrawnPoints = [];
                this.originalCircleCenter = null;
                this.originalCircleRadius = null;
                this.circleCenter = null;
                this.drawingType = null;
                this.isDrawingMode = false;
                this.newFieldName = '';
                this.saveEditedField = false;
                this.editing = false;
                this.oneAction = false;

                this.enableBackButton();
                this.nav.enableMenu = true;
                if (this.agmMap?.googleMap) {
                    this.agmMap.googleMap.setOptions({ draggableCursor: null });
                }
                if (this.farmId) {
                    this.overlayBoundary(this.farmId, this.farmName, 0);
                }
            this.nav.toggleLoading(false);
            }
        });
    }

    disableBackButton() {
        history.pushState(null, null, location.href);

        this.subscription = fromEvent(window, 'popstate').subscribe(_ => {
            history.pushState(null, null, location.href);
        });
    }

    enableBackButton() {
        this.subscription.unsubscribe();
    }

    zoomOutOnTenantChange() {
        this.nav.toggleLoading(true);
        this.activeId = -1;
        this.farmId = -1;
        this.farmName = '';
        this.isAnalysisEmpty = false;
        this.hideAnalysisLabel = true;
        this.farmLegends = [];
        if (!this.tenantChanged && this.zoom === this.maxMapZoom) {
            this.tenantChanged = true;
            this.zoom = 3.1;
        }
        if (this.tenantChanged && this.zoom === 3.1) {
            this.zoom = 3;
        } else {
            this.zoom = 3.1;
        }
        // this.checkIfTenantHasFarms();
        setTimeout(() => {
            this.nav.toggleLoading(false);
        }, 3000);
    }

       setLastSelectedFarm() {
        this.activeId = +sessionStorage.getItem('lastFarmId');
        this.farmName = sessionStorage.getItem('lastFarmName');
        this.handleForceDoubleClick();

        if (this.activeId && this.farmName) {
            this.farmId = this.activeId;
            this.farmManagementService.getFarmBoundingBox(this.activeId).subscribe((boundingBox) => {
                this.farmBounds = new google.maps.LatLngBounds();
                this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));
                this.overlayBoundary(this.activeId, this.farmName, 0);
            });

            this.getMaps();

        }
    }

    getMaps(){
        let mapsTypesAvailabilityDto: MapsTypesAvailabilityDto = { farmId: this.farmId, fieldId: null }
        this.analysisManagementService.getMapsTypesAvailability(mapsTypesAvailabilityDto).subscribe(analysisType => {

        this.analysisTypeAvailable = analysisType;

        // check if at least one item is available  else hide maps button
        const hasAvailableItem = analysisType.some((item) => item.available);
        if ((hasAvailableItem == false && this.farmId == -1) || (hasAvailableItem == false && this.farmId !== -1)) {
            this.isAnalysisEmpty = false;
            this.hideAnalysisLabel = true;
        } else {
            this.isAnalysisEmpty = true;
        }
    });
   }

    //     this.activeId = +sessionStorage.getItem('lastFarmId');
    //     this.farmName = sessionStorage.getItem('lastFarmName');
    //     this.handleForceDoubleClick();

    //     if (this.activeId && this.farmName) {
    //         this.farmManagementService.getFarmBoundingBox(this.activeId).subscribe((boundingBox) => {
    //             this.farmBounds = new google.maps.LatLngBounds();
    //             this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
    //             this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));
    //         });
    //         this.overlayBoundary(this.activeId, this.farmName, 0);
    //         let mapsTypesAvailabilityDto: MapsTypesAvailabilityDto = { farmId: this.farmId, fieldId: null }
    //         this.analysisManagementService.getMapsTypesAvailability(mapsTypesAvailabilityDto).subscribe(analysisType => {

    //             this.analysisTypeAvailable = analysisType;

    //             // check if at least one item is available  else hide maps button
    //             const hasAvailableItem = analysisType.some((item) => item.available);
    //             if ((hasAvailableItem == false && this.farmId == -1) || (hasAvailableItem == false && this.farmId !== -1)) {
    //                 this.isAnalysisEmpty = false;
    //                 this.hideAnalysisLabel = true;
    //             } else {
    //                 this.isAnalysisEmpty = true;infoClick
    //             }
    //         });

    //     }
    // }

    // FORCE DOUBLE CLICK on farm item - work around to fix issue where farm only gets selected on second click sometimes
    handleForceDoubleClick() {
        if (this.selectFarm && this.selectFarm?.nativeElement) {
            let event = new MouseEvent('dblclick', {
                bubbles: true,
                cancelable: true
            });
            this.selectFarm?.nativeElement?.dispatchEvent(event);
        }
    }

    focusBoundingBox(fieldId?: number) {
      this.handleForceDoubleClick();
      this.farmManagementService.getFarmBoundingBox(this.activeId).subscribe((boundingBox) => {
        this.farmBounds = new google.maps.LatLngBounds();
        this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
        this.farmBounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));
      });
      this.activeId = +sessionStorage.getItem('lastFarmId');
      this.farmName = sessionStorage.getItem('lastFarmName');
      this.overlayBoundary(this.activeId, this.farmName, fieldId > 0 ? fieldId : 0);
    }


checkFeatureFlag(featureFlag?: string | boolean): boolean {
  // Handle hardcoded boolean values used for core features available to all
  if (typeof featureFlag === 'boolean') {
    return featureFlag;
  }
  // Handle string feature flags - check with Unleash
  if (typeof featureFlag === 'string') {
    // console.log(`Checking feature flag: ${featureFlag}`);
    const result = this.featureFlagsService.isEnabled(featureFlag);
    // console.log(`Feature flag '${featureFlag}' result:`, result);
    return result;
  }
  // No flag provided = always show - just in case
  return true;
}
//
// checkIfTenantHasFarms() {
//   this. refreshFarmList();
//   this.zoom = this.maxMapZoom;
//
//   if (this.tenantId !== undefined && this.tenantId !== null) {
//     this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
//       if (farms !== null) {
//         this.showAddFarmOption = farms.length == 0;
//         setTimeout(() => {
//           this.nav.toggleLoading(false);
//         }, 3000);
//       } else {
//         this.showAddFarmOption = farms.length == 0;
//         this.nav.toggleLoading(false);
//       }
//     });
//   }
// }
//TO DO REPLACE DUPLICATE CODE WITH THIS METHOD
//   refreshFarmList() {
//     this.farmManagementService.getTenantFarms(this.tenantId).subscribe((farms) => {
//       if (farms != null) {
//         farms.sort((a, b) => a.name.localeCompare(b.name));
//         this.filteredFarms = farms;
//         this.farms = farms;
//         this.farmSubjects.next(farms);
//         let jsonFarms = JSON.stringify(farms);
//         sessionStorage.setItem("farms", jsonFarms);
//       }
//     });
//   }
// }
}